import axios from "axios";
import { SOFTWARE_MATERIAL_CUT_SETTINGS } from "../data-feeds/software-material-cut-settings.js";
const EXPIRATION_MILLISECONDS = 86400000;
export const DIGITAL_CONTENT_API_ENDPOINT = process.env.SISER_WP_CUSTOM_API ?? 'https://admin.leonardodesignstudio.com/siser';
export const MACHINE_TYPE_BROTHER_SCAN_N_CUT = 'brother-scan-n-cut';
export const MACHINE_TYPE_SILHOUETTE_V1 = 'silhouette-v1';
export const MACHINE_TYPE_SILHOUETTE_V2 = 'silhouette-v2';
export const MACHINE_TYPE_SISER_SKYCUT = 'siser-skycut';

// NOTE: This list was originally longer, but was last cut down on 2024-02-06 in order to reduce it to only those cutters that still have not been shipped a roll holder
// noinspection JSUnusedGlobalSymbols
export const ROMEOS_NEEDING_A_ROLL_HOLDER = ['SS241011122080321', 'SS241011122145416', 'SS241021122195121', 'SS241021122205942', 'SS241041022082856', 'SS241041022084501', 'SS241041022090256', 'SS241041022091814', 'SS241041022093626', 'SS241041022101220', 'SS241041022103230', 'SS241041022110146', 'SS241041022162308', 'SS241051022083658', 'SS241051022090750', 'SS241051022094811', 'SS241051022100447', 'SS241051022102109', 'SS241051022150237', 'SS241051022155455', 'SS241051022183334', 'SS241051022200143', 'SS241051022205417', 'SS241051022212117', 'SS241051022214020', 'SS241051022221446', 'SS241061022081719', 'SS241061022095339', 'SS241061022101818', 'SS241061022140426', 'SS241061022142345', 'SS241061022145958', 'SS241061022151938', 'SS241061022153515', 'SS241061022160450', 'SS241061022165300', 'SS241061022165506', 'SS241061022170657', 'SS241061022171022', 'SS241061022195947', 'SS241061022200801', 'SS241061022203505', 'SS241061122085558', 'SS241061122115610', 'SS241061122135428', 'SS241061222171556', 'SS241061222190642', 'SS241071022080718', 'SS241071022081839', 'SS241071022084441', 'SS241071022084608', 'SS241071022090216', 'SS241071022092028', 'SS241071022092121', 'SS241071022093821', 'SS241071022094426', 'SS241071022100231', 'SS241071022102032', 'SS241071022103029', 'SS241071022111547', 'SS241071022113033', 'SS241071022113100', 'SS241071022114500', 'SS241071022133146', 'SS241071022133618', 'SS241071022134800', 'SS241071022135446', 'SS241071022140254', 'SS241071022142836', 'SS241071022160933', 'SS241071022164223', 'SS241071022165925', 'SS241071022184545', 'SS241111022112806', 'SS241130922160726', 'SS241130922170331', 'SS241130922183945', 'SS241200922111133', 'SS241200922114354', 'SS241210922082429', 'SS241210922091356', 'SS241210922140103', 'SS241210922152726', 'SS241210922155408', 'SS241210922164503', 'SS241210922200255', 'SS241210922213509', 'SS241220922083509', 'SS241220922085752', 'SS241220922132950', 'SS241220922143127', 'SS241220922154251', 'SS241220922155012', 'SS241220922170039', 'SS241220922194229', 'SS241220922204610', 'SS241230922081452', 'SS241230922090137', 'SS241230922092755', 'SS241230922094743', 'SS241230922103255', 'SS241230922114442', 'SS241230922143011', 'SS241230922145441', 'SS241230922153320', 'SS241230922170235', 'SS241230922172449', 'SS241230922205421', 'SS241230922220037', 'SS241240922090413', 'SS241240922092852', 'SS241240922095116', 'SS241240922100948', 'SS241240922112006', 'SS241240922163623', 'SS241240922170032', 'SS241240922205718', 'SS241250922094032', 'SS241250922134953', 'SS241250922152602', 'SS241250922155750', 'SS241250922162730', 'SS241260922105832', 'SS241260922143525', 'SS241260922153118', 'SS241260922154848', 'SS241260922161019', 'SS241260922171218', 'SS241260922183514', 'SS241270922082943', 'SS241270922112734', 'SS241270922133313', 'SS241270922152803', 'SS241270922214240', 'SS241280922083641', 'SS241280922091003', 'SS241280922101517', 'SS241280922150323', 'SS241280922162959', 'SS241280922190134', 'SS241280922194343', 'SS241280922200510', 'SS241280922201646', 'SS241280922205957', 'SS241290922082402', 'SS241290922095057', 'SS241290922102847', 'SS241290922112849', 'SS241290922114902', 'SS241290922133903', 'SS241290922154337', 'SS241290922161029', 'SS241290922185208', 'SS241291022084829', 'SS241291022111113', 'SS241291022113930', 'SS241291022115151', 'SS241291022133513', 'SS241300922082636', 'SS241300922101308', 'SS241300922133950', 'SS241300922161557', 'SS241301022150936', 'SS241311022081618', 'SS241311022153201', 'SS241311022155442', 'SS241311022160612', 'SS241311022191900', 'SS242031122100310', 'SS242041022110006', 'SS242051022092517', 'SS242051022110523', 'SS242051022134057', 'SS242051022142229', 'SS242051022152134', 'SS242051022154718', 'SS242051022161654', 'SS242051022164109', 'SS242051022190939', 'SS242051022195716', 'SS242051022202837', 'SS242051022203015', 'SS242051022210405', 'SS242051022212856', 'SS242061022083303', 'SS242061022133323', 'SS242061022135021', 'SS242061022142309', 'SS242061022142951', 'SS242061022145151', 'SS242061022151819', 'SS242061022160506', 'SS242061022163407', 'SS242061022164756', 'SS242061022170214', 'SS242061022183600', 'SS242061022205056', 'SS242061022215648', 'SS242061222190001', 'SS242071022081421', 'SS242071022082739', 'SS242071022090212', 'SS242071022091619', 'SS242071022092412', 'SS242071022093506', 'SS242071022095029', 'SS242071022102537', 'SS242071022103213', 'SS242071022103657', 'SS242071022104823', 'SS242071022110854', 'SS242071022112841', 'SS242071022133457', 'SS242071022133524', 'SS242071022135239', 'SS242071022140253', 'SS242071022141249', 'SS242071022142317', 'SS242071022145653', 'SS242071022150212', 'SS242071022151654', 'SS242071022152937', 'SS242071022154117', 'SS242071022155315', 'SS242071022162352', 'SS242071022163510', 'SS242071022170648', 'SS242071022184754', 'SS242071022193629', 'SS242071022195036', 'SS242140922214027', 'SS242150922162628', 'SS242150922171213', 'SS242160922082259', 'SS242160922084917', 'SS242160922103030', 'SS242160922114459', 'SS242160922143052', 'SS242160922153426', 'SS242160922160040', 'SS242160922195112', 'SS242160922203734', 'SS242160922221644', 'SS242170922082646', 'SS242170922085013', 'SS242170922091842', 'SS242170922101122', 'SS242170922105831', 'SS242170922133613', 'SS242170922154854', 'SS242170922191218', 'SS242170922195055', 'SS242180922084150', 'SS242180922090817', 'SS242180922102336', 'SS242180922150413', 'SS242180922153256', 'SS242180922160200', 'SS242180922162743', 'SS242180922165842', 'SS242190922091814', 'SS242190922104554', 'SS242200922084426', 'SS242200922094426', 'SS242200922105030', 'SS242200922111209', 'SS242200922150228', 'SS242200922161003', 'SS242200922171359', 'SS242200922193121', 'SS242210922083748', 'SS242210922111026', 'SS242210922133532', 'SS242210922140557', 'SS242210922145415', 'SS242210922165311', 'SS242210922191559', 'SS242210922192103', 'SS242210922202558', 'SS242210922203052', 'SS242210922210048', 'SS242210922221255', 'SS242220922100251', 'SS242220922102653', 'SS242220922110145', 'SS242220922112518', 'SS242220922114453', 'SS242220922195447', 'SS242230922134923', 'SS242230922143926', 'SS242230922152049', 'SS242230922160441', 'SS242230922163448', 'SS242230922195746', 'SS242230922210017', 'SS242240922081924', 'SS242240922093917', 'SS242240922112130', 'SS242240922141523', 'SS242240922155711', 'SS242240922161300', 'SS242240922162812', 'SS242240922185952', 'SS242240922195040', 'SS242240922210315', 'SS242250822163605', 'SS242250922100245', 'SS242250922104506', 'SS242250922110134', 'SS242250922112125', 'SS242250922113933', 'SS242250922163640', 'SS242270922134139', 'SS242270922151546', 'SS242270922192637', 'SS242270922211309', 'SS242280922113111', 'SS242280922194850', 'SS242290922083735', 'SS242290922183832', 'SS242290922200903', 'SS242290922210056', 'SS242291022101646', 'SS242301022152343', 'SS242311022183150', 'SS242311022184414', 'SS243031122082901', 'SS243041022091925', 'SS243041022144258', 'SS243041022153815', 'SS243041022161140', 'SS243051022084549', 'SS243051022091552', 'SS243051022114644', 'SS243051022165606', 'SS243051022191910', 'SS243051022195349', 'SS243051022220132', 'SS243051122211707', 'SS243061022080826', 'SS243061022084737', 'SS243061022092004', 'SS243061022101350', 'SS243061022102512', 'SS243061022103856', 'SS243061022115825', 'SS243061022140453', 'SS243061022140950', 'SS243061022141724', 'SS243061022150119', 'SS243061022151311', 'SS243061022152655', 'SS243061022155458', 'SS243061022190333', 'SS243061022192103', 'SS243061022194928', 'SS243061022221722', 'SS243061122082713', 'SS243071022082432', 'SS243071022083115', 'SS243071022090147', 'SS243071022091437', 'SS243071022094851', 'SS243071022100631', 'SS243071022102106', 'SS243071022105304', 'SS243071022105346', 'SS243071022112937', 'SS243071022113428', 'SS243071022133456', 'SS243071022142932', 'SS243071022144505', 'SS243071022150441', 'SS243071022152232', 'SS243071022152315', 'SS243071022153858', 'SS243071022155714', 'SS243071022170840', 'SS243071022191105', 'SS243071022192857', 'SS243081122204542', 'SS243091022102341', 'SS243130922160550', 'SS243130922184013', 'SS243140922111116', 'SS243140922133629', 'SS243140922185950', 'SS243140922202521', 'SS243140922205411', 'SS243140922211734', 'SS243150922093629', 'SS243150922172008', 'SS243150922172702', 'SS243150922190640', 'SS243150922203558', 'SS243150922204611', 'SS243150922214725', 'SS243160922082150', 'SS243160922090010', 'SS243160922201348', 'SS243170922092932', 'SS243170922102924', 'SS243170922110129', 'SS243170922135748', 'SS243170922143213', 'SS243170922153311', 'SS243170922183711', 'SS243170922190258', 'SS243170922202754', 'SS243180922083143', 'SS243180922095520', 'SS243180922104157', 'SS243180922111013', 'SS243180922142204', 'SS243180922145401', 'SS243190922082236', 'SS243190922085243', 'SS243190922092406', 'SS243190922103125', 'SS243190922141121', 'SS243200922084932', 'SS243200922091338', 'SS243200922133858', 'SS243210922111237', 'SS243210922135853', 'SS243210922143302', 'SS243210922151429', 'SS243210922163922', 'SS243210922171648', 'SS243210922211004', 'SS243210922212815', 'SS243220922094632', 'SS243220922193154', 'SS243220922203124', 'SS243230922081517', 'SS243230922093051', 'SS243230922100631', 'SS243230922104314', 'SS243230922135957', 'SS243230922152407', 'SS243230922155259', 'SS243230922161822', 'SS243230922194740', 'SS243230922202107', 'SS243230922215523', 'SS243240922082343', 'SS243240922091632', 'SS243240922100525', 'SS243240922102621', 'SS243240922113433', 'SS243240922135344', 'SS243240922144144', 'SS243240922153706', 'SS243240922170950', 'SS243240922183525', 'SS243240922191113', 'SS243240922205934', 'SS243250922082805', 'SS243250922114945', 'SS243250922140554', 'SS243250922153314', 'SS243260922093913', 'SS243260922211654', 'SS243270922111222', 'SS243270922115022', 'SS243270922200804', 'SS243270922210907', 'SS243280922083848', 'SS243280922091340', 'SS243280922105406', 'SS243280922133834', 'SS243280922144323', 'SS243280922151340', 'SS243280922184427', 'SS243280922194926', 'SS243280922215546', 'SS243290922103807', 'SS243290922111902', 'SS243290922134208', 'SS243290922141524', 'SS243290922152620', 'SS243290922165035', 'SS243290922205805', 'SS243291022094943', 'SS243291022111259', 'SS243291022115356', 'SS243291022140141', 'SS243300922103401', 'SS243300922113116', 'SS243311022145445', 'SS244041122105310', 'SS244051022093523', 'SS244051022140850', 'SS244051022141856', 'SS244051022153358', 'SS244051022154610', 'SS244051022163824', 'SS244051022192706', 'SS244051022220417', 'SS244061022084517', 'SS244061022091959', 'SS244061022093325', 'SS244061022104936', 'SS244061022111120', 'SS244061022112732', 'SS244061022113536', 'SS244061022133141', 'SS244061022133213', 'SS244061022134350', 'SS244061022135041', 'SS244061022135613', 'SS244061022141308', 'SS244061022144213', 'SS244061022144632', 'SS244061022145839', 'SS244061022145851', 'SS244061022150932', 'SS244061022153418', 'SS244061022153524', 'SS244061022161531', 'SS244061022163322', 'SS244061022163837', 'SS244061022183608', 'SS244071022082702', 'SS244071022082754', 'SS244071022083754', 'SS244071022091650', 'SS244071022094148', 'SS244071022094702', 'SS244071022100443', 'SS244071022102520', 'SS244071022104519', 'SS244071022105908', 'SS244071022113154', 'SS244071022115104', 'SS244071022115138', 'SS244071022133721', 'SS244071022134636', 'SS244071022135543', 'SS244071022141431', 'SS244071022143231', 'SS244071022152024', 'SS244071022153805', 'SS244071022154156', 'SS244071022160602', 'SS244071022161630', 'SS244071022163054', 'SS244071022185202', 'SS244071022190505', 'SS244081022102929', 'SS244130922191932', 'SS244130922202824', 'SS244130922212013', 'SS244130922213910', 'SS244140922093305', 'SS244140922100547', 'SS244140922112922', 'SS244140922140142', 'SS244140922141953', 'SS244140922144246', 'SS244140922150527', 'SS244140922153023', 'SS244140922162940', 'SS244140922165146', 'SS244140922185257', 'SS244140922200633', 'SS244140922203751', 'SS244140922205558', 'SS244140922211206', 'SS244140922214031', 'SS244150922082958', 'SS244150922084617', 'SS244150922091117', 'SS244150922092935', 'SS244150922153222', 'SS244150922161703', 'SS244150922163836', 'SS244160922154802', 'SS244160922210924', 'SS244170922093031', 'SS244170922112048', 'SS244170922185622', 'SS244170922204340', 'SS244180922085921', 'SS244180922102056', 'SS244180922103516', 'SS244180922115157', 'SS244180922142015', 'SS244180922144542', 'SS244180922162644', 'SS244180922164147', 'SS244190922082907', 'SS244190922085016', 'SS244190922133722', 'SS244190922141023', 'SS244190922144700', 'SS244190922153013', 'SS244190922170720', 'SS244190922193412', 'SS244190922195113', 'SS244190922201018', 'SS244190922202212', 'SS244190922213645', 'SS244200922082344', 'SS244200922092318', 'SS244200922100918', 'SS244200922110335', 'SS244200922114250', 'SS244200922141145', 'SS244200922165023', 'SS244200922203502', 'SS244200922210108', 'SS244210922101721', 'SS244210922133417', 'SS244210922170020', 'SS244210922204945', 'SS244210922211726', 'SS244220922115112', 'SS244220922160740', 'SS244220922202749', 'SS244230922081239', 'SS244230922095220', 'SS244230922102048', 'SS244230922153633', 'SS244230922160746', 'SS244230922161906', 'SS244240922153442', 'SS244240922161106', 'SS244250922080759', 'SS244250922082901', 'SS244250922133133', 'SS244250922140050', 'SS244250922160051', 'SS244260922200509', 'SS244260922220327', 'SS244270922091153', 'SS244270922102343', 'SS244270922113456', 'SS245041022080539', 'SS245041022084205', 'SS245041022102019', 'SS245041022104842', 'SS245041022110329', 'SS245041022113458', 'SS245051022215029', 'SS245061022085957', 'SS245061022092859', 'SS245061022094110', 'SS245061022141411', 'SS245061022150505', 'SS245061022150925', 'SS245061022153642', 'SS245061022154142', 'SS245061022160411', 'SS245061022163807', 'SS245061022164948', 'SS245061022170421', 'SS245061022184645', 'SS245061022194502', 'SS245061022202836', 'SS245061122152807', 'SS245071022083259', 'SS245071022084746', 'SS245071022091328', 'SS245071022091507', 'SS245071022100843', 'SS245071022102035', 'SS245071022102129', 'SS245071022105452', 'SS245071022110708', 'SS245071022110951', 'SS245071022111907', 'SS245071022113136', 'SS245071022114041', 'SS245071022114344', 'SS245071022134850', 'SS245071022135140', 'SS245071022140043', 'SS245071022143934', 'SS245071022145542', 'SS245071022150052', 'SS245071022150509', 'SS245071022151230', 'SS245071022153147', 'SS245071022154019', 'SS245071022154846', 'SS245071022155046', 'SS245071022160639', 'SS245071022162011', 'SS245071022162143', 'SS245071022194316', 'SS245091022101941', 'SS245091022133528', 'SS245140922082823', 'SS245140922094450', 'SS245140922105635', 'SS245140922114925', 'SS245140922141813', 'SS245140922145601', 'SS245140922153736', 'SS245140922184506', 'SS245140922191159', 'SS245140922193419', 'SS245140922215019', 'SS245140922220003', 'SS245150922161734', 'SS245150922221628', 'SS245160922101511', 'SS245160922112536', 'SS245160922134156', 'SS245160922145214', 'SS245160922151940', 'SS245160922155511', 'SS245160922185812', 'SS245160922194612', 'SS245160922212028', 'SS245170922080926', 'SS245170922083416', 'SS245170922085818', 'SS245170922104525', 'SS245170922114904', 'SS245170922150819', 'SS245170922201039', 'SS245180922082438', 'SS245180922084529', 'SS245180922091243', 'SS245180922093905', 'SS245180922101843', 'SS245180922104203', 'SS245180922114128', 'SS245180922134918', 'SS245180922145743', 'SS245180922163725', 'SS245180922165301', 'SS245190922082319', 'SS245190922084806', 'SS245190922091025', 'SS245190922100145', 'SS245190922104635', 'SS245190922113222', 'SS245190922135336', 'SS245190922152613', 'SS245190922163234', 'SS245190922184007', 'SS245190922201756', 'SS245190922203706', 'SS245200922103900', 'SS245200922105931', 'SS245200922112255', 'SS245200922114714', 'SS245200922134117', 'SS245200922145017', 'SS245200922150944', 'SS245200922152334', 'SS245200922155025', 'SS245200922163050', 'SS245200922163824', 'SS245200922185624', 'SS245200922194431', 'SS245210922084845', 'SS245210922093014', 'SS245210922101019', 'SS245210922105245', 'SS245210922140957', 'SS245210922150342', 'SS245210922161520', 'SS245210922164414', 'SS245220922101553', 'SS245220922112333', 'SS245220922144839', 'SS245220922151616', 'SS245220922170701', 'SS245220922183433', 'SS245220922194849', 'SS245230922192228', 'SS245240922080354', 'SS245240922095723', 'SS245240922143329', 'SS245240922155453', 'SS245240922211457', 'SS245250922082255', 'SS245250922114210', 'SS245250922135555', 'SS245250922152359', 'SS245250922165029', 'SS245260922203205', 'SS245260922212101', 'SS245280922144635', 'SS245280922151201', 'SS245280922153044', 'SS245280922160223', 'SS245280922163831', 'SS245280922183031', 'SS245280922190013', 'SS245280922204742', 'SS245280922211528', 'SS245280922220649', 'SS245290922134036', 'SS245290922195416', 'SS245290922201553', 'SS245290922215324', 'SS245300922082829', 'SS245300922090555', 'SS245300922100734', 'SS245300922103544', 'SS246031122084510', 'SS246041022084913', 'SS246041022093238', 'SS246041022103857', 'SS246041022143811', 'SS246041022152108', 'SS246041022161416', 'SS246041122202843', 'SS246051022191221', 'SS246051022195355', 'SS246061022094837', 'SS246061022113838', 'SS246061022134646', 'SS246061022141832', 'SS246061022150901', 'SS246061022151334', 'SS246061022152630', 'SS246061022162758', 'SS246061022172749', 'SS246061022204209', 'SS246061022222259', 'SS246061122105153', 'SS246061122111744', 'SS246061122115639', 'SS246061222183641', 'SS246071022082754', 'SS246071022091155', 'SS246071022092549', 'SS246071022094524', 'SS246071022095405', 'SS246071022102220', 'SS246071022103406', 'SS246071022105045', 'SS246071022105609', 'SS246071022110249', 'SS246071022111240', 'SS246071022113805', 'SS246071022114853', 'SS246071022150819', 'SS246071022151143', 'SS246071022152700', 'SS246071022160028', 'SS246071022164016', 'SS246071022165350', 'SS246071022172705', 'SS246071122095341', 'SS246111222095843', 'SS246130922184509', 'SS246220922170413', 'SS246220922172356', 'SS246220922185154', 'SS246220922200635', 'SS246220922205233', 'SS246220922214318', 'SS246220922221242', 'SS246230922095001', 'SS246230922135725', 'SS246230922163132', 'SS246230922172724', 'SS246230922191024', 'SS246240922083249', 'SS246240922101708', 'SS246240922113126', 'SS246240922152913', 'SS246240922164344', 'SS246240922190122', 'SS246240922203004', 'SS246240922210702', 'SS246250922104756', 'SS246250922160306', 'SS246260922214201', 'SS246260922221455', 'SS246270922090715', 'SS246270922092528', 'SS246270922101321', 'SS246270922200638', 'SS246270922210519', 'SS246271022203808', 'SS246280922083936', 'SS246280922090225', 'SS246280922102117', 'SS246280922135343', 'SS246280922141810', 'SS246280922144757', 'SS246280922152539', 'SS246280922184515', 'SS246280922193021', 'SS246280922200229', 'SS246280922213220', 'SS246280922215253', 'SS246290922101410', 'SS246290922103153', 'SS246290922105351', 'SS246290922112404', 'SS246290922133958', 'SS246290922152307', 'SS246290922163919', 'SS246290922183103', 'SS246290922184923', 'SS246290922193115', 'SS246290922200406', 'SS246290922202217', 'SS246290922211136', 'SS246291022112736', 'SS246300922083219', 'SS246300922095055', 'SS246300922095932', 'SS246300922102127', 'SS246300922105006', 'SS246300922111854', 'SS246300922113510', 'SS246300922161740', 'SS246300922170245', 'SS246301022144201', 'SS246311022140129', 'SS246311022162611', 'SS247061022094343', 'SS247061022100202', 'SS247061022102602', 'SS247061022115314', 'SS247061022135937', 'SS247061022150247', 'SS247061022155642', 'SS247061022161041', 'SS247061022162359', 'SS247061022163653', 'SS247061022171654', 'SS247061022185120', 'SS247061022215319', 'SS247071022082123', 'SS247071022090159', 'SS247071022092552', 'SS247071022100349', 'SS247071022101749', 'SS247071022102925', 'SS247071022104625', 'SS247071022110045', 'SS247071022113252', 'SS247071022114322', 'SS247071022140003', 'SS247071022153728', 'SS247081122192506', 'SS247161122140436', 'SS247260922202557', 'SS247260922204105', 'SS247270922140213', 'SS247281022193620', 'SS247281022213310', 'SS247291022113607', 'SS247291022114838', 'SS247301022151415', 'SS247301022153537', 'SS247301022154813', 'SS247311022151222', 'SS247311022155746', 'SS248021122111921', 'SS248021122213447', 'SS248031122091020', 'SS248051122211517', 'SS248061122085734', 'SS248061122133320', 'SS248061122140929', 'SS248301022150750', 'SS248301022155139', 'SS248311022150224', 'SS248311022214107', 'SS249291022192929', 'SS249311022153141', 'SS249311022161426'];

// noinspection JSUnusedGlobalSymbols
export const modelsInfo = {
  "": {
    active: false,
    selectImageUrl: '',
    imageUrl: '',
    manualUrl: '',
    modelNumber: '',
    name: '',
    shortName: '',
    software: '',
    type: "",
    barcodeScanning: false
  },
  "SNAHDCJ12": {
    active: true,
    selectImageUrl: process.env.CDN_URL + '/images/products/SNAHDCJ12.svg',
    imageUrl: process.env.CDN_URL + '/images/products/SNAHDCJ12-img.svg',
    manualUrl: process.env.CDN_URL + '/pdfs/craft-press-manual.pdf',
    // TODO: change this to the correct manual when available
    modelNumber: 'SNAHDCJ12',
    name: "Siser® Juliet® 12-inch Cutter",
    shortName: "Juliet® Cutter",
    software: 'LDS',
    type: "cutter",
    barcodeScanning: true
  },
  "SNAHDCR24": {
    active: true,
    selectImageUrl: process.env.CDN_URL + '/images/products/SNAHDCR24.svg',
    imageUrl: process.env.CDN_URL + '/images/products/SNAHDCR24-img.svg',
    manualUrl: process.env.CDN_URL + '/pdfs/craft-press-manual.pdf',
    // TODO: change this to the correct manual when available
    modelNumber: 'SNAHDCR24',
    name: "Siser® Romeo® 24-inch Cutter",
    shortName: "Romeo® Cutter",
    software: 'LDS',
    type: "cutter",
    barcodeScanning: true
  },
  "CP912-120": {
    active: true,
    selectImageUrl: process.env.CDN_URL + '/images/products/heat-press.svg',
    imageUrl: process.env.CDN_URL + '/images/products/heat-press.svg',
    manualUrl: process.env.CDN_URL + '/pdfs/craft-press-manual.pdf',
    // TODO: change this to the correct manual when available
    modelNumber: 'CP912-120',
    name: "Siser® Craft Heat Press",
    shortName: "Craft Heat Press",
    software: null,
    type: "heat-press",
    barcodeScanning: false
  },
  "TBD-HEAT-PRESS": {
    active: false,
    selectImageUrl: '',
    imageUrl: '',
    manualUrl: '',
    // TODO: change this to the correct manual when available
    modelNumber: 'TBD-HEAT-PRESS',
    name: "",
    shortName: "",
    software: null,
    type: "heat-press",
    barcodeScanning: true
  },
  "TBD-LIGHT-PAD": {
    active: false,
    selectImageUrl: '',
    imageUrl: '',
    manualUrl: '',
    // TODO: change this to the correct manual when available
    modelNumber: 'TBD-LIGHT-PAD"',
    name: "",
    shortName: "",
    software: null,
    type: "light-pad",
    barcodeScanning: true
  }
};

// noinspection JSUnusedGlobalSymbols
export function listMaterialCutSettings(languageCode) {
  let newCutSettings = {
    base_setting_types: {},
    material_types: {}
  };
  for (const [key, val] of Object.entries(SOFTWARE_MATERIAL_CUT_SETTINGS.base_setting_types)) {
    val['name'] = val['name_translations'][languageCode] ?? val['name'];
    newCutSettings.base_setting_types[key] = val;
  }
  for (const [key, val] of Object.entries(SOFTWARE_MATERIAL_CUT_SETTINGS.material_types)) {
    val['name'] = val['name_translations'][languageCode] ?? val['name'];
    newCutSettings.material_types[key] = val;
  }
  return newCutSettings;
}
export function listMachines() {
  return {
    "expiry": null,
    "loaded_from_cache": false,
    "machine_types": {
      [MACHINE_TYPE_BROTHER_SCAN_N_CUT]: {
        "models": {
          "CM350E": {
            "model_number": "CM350E",
            "name": "ScanNCut2 CM350e"
          },
          "RSDX125E": {
            "model_number": "RSDX125E",
            "name": "RSDX125E"
          },
          "SDX125Ee": {
            "model_number": "SDX125e",
            "name": "ScanNCut SDX125e"
          },
          "SDX125EGY": {
            "model_number": "SDX125EGY",
            "name": "ScanNCut DX"
          }
        },
        "name": "Brother ScanNCut",
        "type": MACHINE_TYPE_BROTHER_SCAN_N_CUT
      },
      [MACHINE_TYPE_SILHOUETTE_V1]: {
        "models": {
          "SILH-PORTRAIT-3-4T": {
            "model_number": 'SILH-PORTRAIT-3-4T',
            "name": 'Silhouette Portrait® 3'
          },
          'SILHOUETTE CAMEO': {
            "model_number": 'SILHOUETTE CAMEO',
            "name": 'Silhouette CAMEO®'
          },
          "SILHOUETTE PORTRAIT": {
            "model_number": 'SILHOUETTE PORTRAIT',
            "name": 'Silhouette Portrait®'
          },
          "SILHOUETTE-CAMEO-2-3T": {
            "model_number": 'SILHOUETTE-CAMEO-2-3T',
            "name": 'Silhouette Cameo® 2'
          },
          "SILHOUETTE-CAMEO-3-3T": {
            "model_number": 'SILHOUETTE-CAMEO-3-3T',
            "name": 'Silhouette Cameo® 3'
          },
          "SILHOUETTE-CURIO-3T": {
            "model_number": 'SILHOUETTE-CURIO-3T',
            "name": 'Silhouette Curio®'
          },
          "SILHOUETTE-PORTRAIT-2-4T": {
            "model_number": 'SILHOUETTE-PORTRAIT-2-4T',
            "name": 'Silhouette Portrait® 2'
          }
        },
        "name": 'Silhouette Vinyl Cutters V1',
        "type": MACHINE_TYPE_SILHOUETTE_V1
      },
      [MACHINE_TYPE_SILHOUETTE_V2]: {
        "models": {
          "SILH-CAMEO-4-PLUS-4T": {
            "model_number": 'SILH-CAMEO-4-PLUS-4T',
            "name": 'Silhouette Cameo® 4 Plus'
          },
          "SILH-CAMEO-4-PRO-4T": {
            "model_number": 'SILH-CAMEO-4-PRO-4T',
            "name": 'Silhouette Cameo® 4 Pro'
          },
          "SILH-CAMEO-4-WHT-4T": {
            "model_number": 'SILH-CAMEO-4-WHT-4T',
            "name": 'Silhouette Cameo® 4'
          }
        },
        "name": 'Silhouette Vinyl Cutters V2',
        "type": MACHINE_TYPE_SILHOUETTE_V2
      },
      [MACHINE_TYPE_SISER_SKYCUT]: {
        "models": {
          "SNAHDCJ12": {
            "model_number": 'SNAHDCJ12',
            "name": "Siser® Juliet 12-inch Cutter"
          },
          "SNAHDCR24": {
            "model_number": 'SNAHDCR24',
            "name": "Siser® Romeo 24-inch Cutter"
          }
        },
        "name": "Siser Romeo® & Juliet® Series",
        "type": MACHINE_TYPE_SISER_SKYCUT
      }
    }
  };
}

/**
 *
 * @param successCallback
 * @param errorCallback
 */
export function listMaterials(successCallback, errorCallback) {
  const SESSION_KEY = 'materials-list';
  if (typeof window !== 'undefined') {
    let cachedMaterials = window.sessionStorage.getItem(SESSION_KEY);
    if (cachedMaterials != null) {
      successCallback(JSON.parse(cachedMaterials));
      return;
    }
  }
  axios.get(DIGITAL_CONTENT_API_ENDPOINT + '/digital-content/materials/?compression=gzip', {
    responseType: 'json'
  }).then(response => {
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(response.data));
    }
    successCallback(response.data);
  }).catch(err => {
    errorCallback(err);
  });
}
export function listMaterialsUrl(compression) {
  const VALID_COMPRESSION_OPTIONS = ['', 'gzip', 'zip'];
  if (typeof compression === 'undefined' || !VALID_COMPRESSION_OPTIONS.includes(compression)) {
    compression = '';
  }
  return {
    "url": DIGITAL_CONTENT_API_ENDPOINT + '/digital-content/materials/?compression=' + compression
  };
}

// noinspection JSUnusedGlobalSymbols
export function listMaterialsDisconnectedFallbackData() {
  // fallback generated 2023-02-20
  return {
    "expiry": Date.now() + EXPIRATION_MILLISECONDS,
    "loaded_from_cache": true,
    "material_types": {
      "aurora": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "aurora",
        "materials": [],
        "name": "Aurora\u2122",
        "aurora-pink": {
          "id": "aurora-pink",
          "name": "Aurora\u2122 Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105724\/aurora-light-pink.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105724\/aurora-light-pink-150x150.png"
          }
        },
        "aurora-light-blue": {
          "id": "aurora-light-blue",
          "name": "Aurora\u2122 Light Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105356\/aurora-light-blue.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105356\/aurora-light-blue-150x150.png"
          }
        },
        "aurora-borealis-teal": {
          "id": "aurora-borealis-teal",
          "name": "Aurora\u2122 Borealis Teal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105046\/aurora-borealis-teal.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105046\/aurora-borealis-teal-150x150.png"
          }
        },
        "aurora-light-green": {
          "id": "aurora-light-green",
          "name": "Aurora\u2122 Light Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105540\/aurora-light-green.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105540\/aurora-light-green-150x150.png"
          }
        },
        "aurora-goldish": {
          "id": "aurora-goldish",
          "name": "Aurora\u2122 Goldish",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105240\/aurora-golden.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105240\/aurora-golden-150x150.png"
          }
        },
        "aurora-yellow": {
          "id": "aurora-yellow",
          "name": "Aurora\u2122 Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110527\/aurora-yellow.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110527\/aurora-yellow-150x150.png"
          }
        },
        "aurora-red": {
          "id": "aurora-red",
          "name": "Aurora\u2122 Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110042\/aurora-red.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110042\/aurora-red-150x150.png"
          }
        },
        "aurora-parakeet": {
          "id": "aurora-parakeet",
          "name": "Aurora\u2122 Parakeet",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105857\/aurora-parakeet.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105857\/aurora-parakeet-150x150.png"
          }
        },
        "aurora-silver": {
          "id": "aurora-silver",
          "name": "Aurora\u2122 Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110223\/aurora-silver.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110223\/aurora-silver-150x150.png"
          }
        },
        "aurora-white": {
          "id": "aurora-white",
          "name": "Aurora\u2122 White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110354\/aurora-white.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110354\/aurora-white-150x150.png"
          }
        }
      },
      "blackboard": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 15,
              "speed": 10
            }
          }
        },
        "id": "blackboard",
        "materials": [],
        "name": "Blackboard\u00ae",
        "blackboard": {
          "id": "blackboard",
          "name": "Blackboard\u00ae",
          "solid_hex_color": "#232323",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "brick-600": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 60,
              "force": 12,
              "speed": 10
            }
          }
        },
        "id": "brick-600",
        "materials": [],
        "name": "Brick\u00ae 600",
        "brick-fluorescent-blue": {
          "id": "brick-fluorescent-blue",
          "name": "Brick\u00ae 600 Fluorescent Blue",
          "solid_hex_color": "#0077CF",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-fluorescent-pink": {
          "id": "brick-fluorescent-pink",
          "name": "Brick\u00ae 600 Fluorescent Pink",
          "solid_hex_color": "#FF48B0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-fluorescent-green": {
          "id": "brick-fluorescent-green",
          "name": "Brick\u00ae 600 Fluorescent Green",
          "solid_hex_color": "#3BD23D",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-fluorescent-orange": {
          "id": "brick-fluorescent-orange",
          "name": "Brick\u00ae 600 Fluorescent Orange",
          "solid_hex_color": "#FF8F6C",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-fluorescent-yellow": {
          "id": "brick-fluorescent-yellow",
          "name": "Brick\u00ae 600 Fluorescent Yellow",
          "solid_hex_color": "#E3E829",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-navy-blue": {
          "id": "brick-navy-blue",
          "name": "Brick\u00ae 600 Navy Blue",
          "solid_hex_color": "#414C60",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-royal-blue": {
          "id": "brick-royal-blue",
          "name": "Brick\u00ae 600 Royal Blue",
          "solid_hex_color": "#34558B",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-green": {
          "id": "brick-green",
          "name": "Brick\u00ae 600 Green",
          "solid_hex_color": "#376C59",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-yellow": {
          "id": "brick-yellow",
          "name": "Brick\u00ae 600 Yellow",
          "solid_hex_color": "#FEB236",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-red": {
          "id": "brick-red",
          "name": "Brick\u00ae 600 Red",
          "solid_hex_color": "#8A2A2B",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-black": {
          "id": "brick-black",
          "name": "Brick\u00ae 600 Black",
          "solid_hex_color": "#3B3F42",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-white": {
          "id": "brick-white",
          "name": "Brick\u00ae 600 White",
          "solid_hex_color": "#EFF0F1",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "colorprint-easy-semigloss": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "colorprint-easy-semigloss",
        "materials": [],
        "name": "ColorPrint Easy (Semi-Gloss)",
        "colorprint-easy": {
          "id": "colorprint-easy",
          "name": "ColorPrint Easy (Semi-Gloss)",
          "solid_hex_color": "#fcfcfc",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "colorprint-extra-pu-semigloss": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "colorprint-extra-pu-semigloss",
        "materials": [],
        "name": "ColorPrint Extra PU (Semi-Gloss)",
        "colorprint-extra-pu": {
          "id": "colorprint-extra-pu",
          "name": "ColorPrint Extra PU (Semi-Gloss)",
          "solid_hex_color": "#f9f9f9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "colorprint-pu-gloss": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "colorprint-pu-gloss",
        "materials": [],
        "name": "ColorPrint PU (Gloss)",
        "colorprint-pu-gloss": {
          "id": "colorprint-pu-gloss",
          "name": "ColorPrint PU (Gloss)",
          "solid_hex_color": "#f7f7f7",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "colorprint-pu-matte": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "colorprint-pu-matte",
        "materials": [],
        "name": "ColorPrint PU (Matte)",
        "colorprint-pu-matte": {
          "id": "colorprint-pu-matte",
          "name": "ColorPrint PU (Matte)",
          "solid_hex_color": "#f4f4f4",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "diamond-dust": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "diamond-dust",
        "materials": [],
        "name": "Diamond Dust\u2122",
        "diamond-dust-wild-cherry": {
          "id": "diamond-dust-wild-cherry",
          "name": "Diamond Dust\u2122 Wild Cherry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115832\/dust-wild-cherry.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115832\/dust-wild-cherry-150x150.jpeg"
          }
        },
        "diamond-dust-sour-apple": {
          "id": "diamond-dust-sour-apple",
          "name": "Diamond Dust\u2122 Sour Apple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115831\/dust-sour-apple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115831\/dust-sour-apple-150x150.jpeg"
          }
        },
        "diamond-dust-pink-salt": {
          "id": "diamond-dust-pink-salt",
          "name": "Diamond Dust\u2122 Pink Salt",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115830\/dust-pink-salt.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115830\/dust-pink-salt-150x150.jpeg"
          }
        },
        "diamond-dust-pastel-lilac": {
          "id": "diamond-dust-pastel-lilac",
          "name": "Diamond Dust\u2122 Pastel Lilac",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115829\/dust-pastel-lilac.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115829\/dust-pastel-lilac-150x150.jpeg"
          }
        },
        "diamond-dust-orange-slice": {
          "id": "diamond-dust-orange-slice",
          "name": "Diamond Dust\u2122 Orange Slice",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115828\/dust-orange-slice.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115828\/dust-orange-slice-150x150.jpeg"
          }
        },
        "diamond-dust-dream-gray": {
          "id": "diamond-dust-dream-gray",
          "name": "Diamond Dust\u2122 Dream Gray",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115828\/dust-dream-gray.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115828\/dust-dream-gray-150x150.jpeg"
          }
        },
        "diamond-dust-cinnamon-rose": {
          "id": "diamond-dust-cinnamon-rose",
          "name": "Diamond Dust\u2122 Cinnamon Rose",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115827\/dust-cinnamon-rose.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115827\/dust-cinnamon-rose-150x150.jpeg"
          }
        },
        "diamond-dust-blue-raspberry": {
          "id": "diamond-dust-blue-raspberry",
          "name": "Diamond Dust\u2122 Blue Raspberry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115525\/dust-blue-raspberry.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115525\/dust-blue-raspberry-150x150.jpeg"
          }
        }
      },
      "digibrick-matte": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "digibrick-matte",
        "materials": [],
        "name": "DigiBrick (Matte)\u2122",
        "digibrick": {
          "id": "digibrick",
          "name": "DigiBrick\u2122",
          "solid_hex_color": "#f2f2f2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easycolor-dtv": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easycolor-dtv",
        "materials": [],
        "name": "EasyColor\u2122 DTV\u2122",
        "easycolor-dtv": {
          "id": "easycolor-dtv",
          "name": "EasyColor\u2122 DTV\u2122",
          "solid_hex_color": "#e0e0e0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easypatterns-plus": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easypatterns-plus",
        "materials": [],
        "name": "EasyPatterns\u00ae Plus",
        "epp-mood-ring": {
          "id": "epp-mood-ring",
          "name": "EasyPatterns\u00ae Plus Mood Ring",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/01101542\/Mood-Ring_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/01101542\/Mood-Ring_Tile-150x150.jpg"
          }
        },
        "epp-kuba-cloth": {
          "id": "epp-kuba-cloth",
          "name": "EasyPatterns\u00ae Plus Kuba Cloth",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144851\/Kuba-Cloth_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144851\/Kuba-Cloth_Tile-150x150.jpg"
          }
        },
        "epp-tie-dye": {
          "id": "epp-tie-dye",
          "name": "EasyPatterns\u00ae Plus Tie Dye",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144916\/Tie-Dye_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144916\/Tie-Dye_Tile-150x150.jpg"
          }
        },
        "epp-terrazzo": {
          "id": "epp-terrazzo",
          "name": "EasyPatterns\u00ae Plus Terrazzo",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144913\/Terrazzo_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144913\/Terrazzo_Tile-150x150.jpg"
          }
        },
        "epp-tortoise-shell": {
          "id": "epp-tortoise-shell",
          "name": "EasyPatterns\u00ae Plus Tortoise Shell",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144918\/Tortoise-Shell_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144918\/Tortoise-Shell_Tile-150x150.jpg"
          }
        },
        "epp-ocean-waves": {
          "id": "epp-ocean-waves",
          "name": "EasyPatterns\u00ae Plus Ocean Waves",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144905\/Ocean-Waves_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144905\/Ocean-Waves_Tile-150x150.jpg"
          }
        },
        "epp-carbon-fiber": {
          "id": "epp-carbon-fiber",
          "name": "EasyPatterns\u00ae Plus Carbon Fiber",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144827\/Carbon-Fiber_Tile-1.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144827\/Carbon-Fiber_Tile-1.jpg"
          }
        },
        "epp-watercolor-rainbow": {
          "id": "epp-watercolor-rainbow",
          "name": "EasyPatterns\u00ae Plus Watercolor Rainbow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144925\/Watercolor-Rainbow_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144925\/Watercolor-Rainbow_Tile-150x150.jpg"
          }
        },
        "epp-vintage-rose": {
          "id": "epp-vintage-rose",
          "name": "EasyPatterns\u00ae Plus Vintage Rose",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144921\/Vintage-Rose_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144921\/Vintage-Rose_Tile-150x150.jpg"
          }
        },
        "epp-tropical-leaves": {
          "id": "epp-tropical-leaves",
          "name": "EasyPatterns\u00ae Plus Tropical Leaves",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144920\/Tropical-Leaves_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144920\/Tropical-Leaves_Tile-150x150.jpg"
          }
        },
        "epp-sunset-gradient": {
          "id": "epp-sunset-gradient",
          "name": "EasyPatterns\u00ae Plus Sunset Gradient",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144912\/Sunset-Gradient_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144912\/Sunset-Gradient_Tile-150x150.jpg"
          }
        },
        "epp-serape": {
          "id": "epp-serape",
          "name": "EasyPatterns\u00ae Plus Serape",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144910\/Serape_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144910\/Serape_Tile-150x150.jpg"
          }
        },
        "epp-paisley-party": {
          "id": "epp-paisley-party",
          "name": "EasyPatterns\u00ae Plus Paisley Party",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144907\/Paisley-Party_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144907\/Paisley-Party_Tile-150x150.jpg"
          }
        },
        "epp-mermaid-scales": {
          "id": "epp-mermaid-scales",
          "name": "EasyPatterns\u00ae Plus Mermaid Scales",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144857\/Mermaid-Scales_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144857\/Mermaid-Scales_Tile-150x150.jpg"
          }
        },
        "epp-leopard-tan": {
          "id": "epp-leopard-tan",
          "name": "EasyPatterns\u00ae Plus Leopard Tan",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/01101531\/Leopard-Tan_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/01101531\/Leopard-Tan_Tile-150x150.jpg"
          }
        },
        "epp-kente": {
          "id": "epp-kente",
          "name": "EasyPatterns\u00ae Plus Kente",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/31091034\/Kente_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/31091034\/Kente_Tile-150x150.jpg"
          }
        },
        "epp-jambo": {
          "id": "epp-jambo",
          "name": "EasyPatterns\u00ae Plus Jambo",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144849\/Jambo_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144849\/Jambo_Tile-150x150.jpg"
          }
        },
        "epp-infinite-galaxy": {
          "id": "epp-infinite-galaxy",
          "name": "EasyPatterns\u00ae Plus Infinite Galaxy",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144845\/Infinite-Galaxy_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144845\/Infinite-Galaxy_Tile-150x150.jpg"
          }
        },
        "epp-camo-green": {
          "id": "epp-camo-green",
          "name": "EasyPatterns\u00ae Plus Camo Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144826\/Camo-Green_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144826\/Camo-Green_Tile-150x150.jpg"
          }
        },
        "epp-buffalo-plaid-red": {
          "id": "epp-buffalo-plaid-red",
          "name": "EasyPatterns\u00ae Plus Buffalo Plaid Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144819\/Buffalo-Plaid-Red_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144819\/Buffalo-Plaid-Red_Tile.jpg"
          }
        },
        "epp-grunge": {
          "id": "epp-grunge",
          "name": "EasyPatterns\u00ae Plus Grunge",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144833\/Grunge_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144833\/Grunge_Tile-150x150.jpg"
          }
        },
        "epp-watercolor-plaid": {
          "id": "epp-watercolor-plaid",
          "name": "EasyPatterns\u00ae Plus Watercolor Plaid",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144923\/Watercolor-Plaid_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144923\/Watercolor-Plaid_Tile-150x150.jpg"
          }
        },
        "epp-bohemian-stripes": {
          "id": "epp-bohemian-stripes",
          "name": "EasyPatterns\u00ae Plus Bohemian Stripes",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144818\/Bohemian-Stripes_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144818\/Bohemian-Stripes_Tile-150x150.jpg"
          }
        }
      },
      "easypatterns-plus-glow": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easypatterns-plus-glow",
        "materials": [],
        "name": "EasyPatterns\u00ae Plus Glow",
        "epp-glow-spiderwebs": {
          "id": "epp-glow-spiderwebs",
          "name": "EasyPatterns\u00ae Plus Glow Spiderwebs",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/09\/23084151\/Spiderweb_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/09\/23084151\/Spiderweb_Tile-150x150.jpg"
          }
        },
        "epp-glow-lightning": {
          "id": "epp-glow-lightning",
          "name": "EasyPatterns\u00ae Plus Glow Lightning",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/09\/23084150\/Lightning_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/09\/23084150\/Lightning_Tile-150x150.jpg"
          }
        }
      },
      "easypatterns-plus-sparkle": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easypatterns-plus-sparkle",
        "materials": [],
        "name": "EasyPatterns\u00ae Plus Sparkle",
        "easypatterns-plus-sparkle-winter-stars": {
          "id": "easypatterns-plus-sparkle-winter-stars",
          "name": "EasyPatterns\u00ae Plus Sparkle Winter Stars",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/12\/07102817\/Winter-Stars_Sparkleprint.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/12\/07102817\/Winter-Stars_Sparkleprint-150x150.jpg"
          }
        },
        "easypatterns-plus-sparkle-candy-stripes": {
          "id": "easypatterns-plus-sparkle-candy-stripes",
          "name": "EasyPatterns\u00ae Plus Sparkle Candy Stripes",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/12\/07102634\/Candy-Stripes_Sparkleprint.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/12\/07102634\/Candy-Stripes_Sparkleprint-150x150.jpg"
          }
        }
      },
      "easypsv-solid-colors": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easypsv-solid-colors",
        "materials": [],
        "name": "EasyPSV\u00ae (Solid Colors)",
        "psv-rose-gold": {
          "id": "psv-rose-gold",
          "name": "EasyPSV\u00ae Rose Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115157\/psv-rose-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115157\/psv-rose-gold-150x150.png"
          }
        },
        "psv-tropical-pink": {
          "id": "psv-tropical-pink",
          "name": "EasyPSV\u00ae Tropical Pink",
          "solid_hex_color": "#CB335C",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-carnation-pink": {
          "id": "psv-carnation-pink",
          "name": "EasyPSV\u00ae Carnation Pink",
          "solid_hex_color": "#F57EB6",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-cherry-blossom-pink": {
          "id": "psv-cherry-blossom-pink",
          "name": "EasyPSV\u00ae Cherry Blossom Pink",
          "solid_hex_color": "#EDD2E0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-light-orchid": {
          "id": "psv-light-orchid",
          "name": "EasyPSV\u00ae Light Orchid",
          "solid_hex_color": "#C6A1CF",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-wisteria": {
          "id": "psv-wisteria",
          "name": "EasyPSV\u00ae Wisteria",
          "solid_hex_color": "#8272AD",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-violet": {
          "id": "psv-violet",
          "name": "EasyPSV\u00ae Violet",
          "solid_hex_color": "#764C82",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-royal-purple": {
          "id": "psv-royal-purple",
          "name": "EasyPSV\u00ae Royal Purple",
          "solid_hex_color": "#483698",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-twilight-navy": {
          "id": "psv-twilight-navy",
          "name": "EasyPSV\u00ae Twilight Navy",
          "solid_hex_color": "#003057",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-soft-blue": {
          "id": "psv-soft-blue",
          "name": "EasyPSV\u00ae Soft Blue",
          "solid_hex_color": "#ADCFF1",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-cobalt": {
          "id": "psv-cobalt",
          "name": "EasyPSV\u00ae Cobalt",
          "solid_hex_color": "#00447B",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-nautical-blue": {
          "id": "psv-nautical-blue",
          "name": "EasyPSV\u00ae Nautical Blue",
          "solid_hex_color": "#0057B8",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-blue-skies": {
          "id": "psv-blue-skies",
          "name": "EasyPSV\u00ae Blue Skies",
          "solid_hex_color": "#41B6E6",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-totally-teal": {
          "id": "psv-totally-teal",
          "name": "EasyPSV\u00ae Totally Teal",
          "solid_hex_color": "#00919D",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-aqua": {
          "id": "psv-aqua",
          "name": "EasyPSV\u00ae Aqua",
          "solid_hex_color": "#00ACA0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-fresh-mint": {
          "id": "psv-fresh-mint",
          "name": "EasyPSV\u00ae Fresh Mint",
          "solid_hex_color": "#A0EAC5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-emerald": {
          "id": "psv-emerald",
          "name": "EasyPSV\u00ae Emerald",
          "solid_hex_color": "#008755",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-turtle-green": {
          "id": "psv-turtle-green",
          "name": "EasyPSV\u00ae Turtle Green",
          "solid_hex_color": "#154734",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-bright-green": {
          "id": "psv-bright-green",
          "name": "EasyPSV\u00ae Bright Green",
          "solid_hex_color": "#78D64B",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-alligator-green": {
          "id": "psv-alligator-green",
          "name": "EasyPSV\u00ae Alligator Green",
          "solid_hex_color": "#808956",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-citrus": {
          "id": "psv-citrus",
          "name": "EasyPSV\u00ae Citrus",
          "solid_hex_color": "#E1E000",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-canary-yellow": {
          "id": "psv-canary-yellow",
          "name": "EasyPSV\u00ae Canary Yellow",
          "solid_hex_color": "#F9E547",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-dandelion": {
          "id": "psv-dandelion",
          "name": "EasyPSV\u00ae Dandelion",
          "solid_hex_color": "#FED141",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-cream-and-sugar": {
          "id": "psv-cream-and-sugar",
          "name": "EasyPSV\u00ae Cream & Sugar",
          "solid_hex_color": "#F4E1AD",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-camel": {
          "id": "psv-camel",
          "name": "EasyPSV\u00ae Camel",
          "solid_hex_color": "#C6AA76",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-golden": {
          "id": "psv-golden",
          "name": "EasyPSV\u00ae Golden",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115016\/psv-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115016\/psv-gold-150x150.png"
          }
        },
        "psv-coffee": {
          "id": "psv-coffee",
          "name": "EasyPSV\u00ae Coffee",
          "solid_hex_color": "#70594D",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-coral-reef": {
          "id": "psv-coral-reef",
          "name": "EasyPSV\u00ae Coral Reef",
          "solid_hex_color": "#FF8C91",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-orange-soda": {
          "id": "psv-orange-soda",
          "name": "EasyPSV\u00ae Orange Soda",
          "solid_hex_color": "#Ff6900",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-orange": {
          "id": "psv-orange",
          "name": "EasyPSV\u00ae Orange",
          "solid_hex_color": "#E34F33",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-ketchup": {
          "id": "psv-ketchup",
          "name": "EasyPSV\u00ae Ketchup",
          "solid_hex_color": "#BC3D3A",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-persimmon": {
          "id": "psv-persimmon",
          "name": "EasyPSV\u00ae Persimmon",
          "solid_hex_color": "#E10600",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-holly-berry": {
          "id": "psv-holly-berry",
          "name": "EasyPSV\u00ae Holly Berry",
          "solid_hex_color": "#9E2A2F",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-merlot": {
          "id": "psv-merlot",
          "name": "EasyPSV\u00ae Merlot",
          "solid_hex_color": "#651D32",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-black-cat": {
          "id": "psv-black-cat",
          "name": "EasyPSV\u00ae Black Cat",
          "solid_hex_color": "#3B3C40",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-graphite": {
          "id": "psv-graphite",
          "name": "EasyPSV\u00ae Graphite",
          "solid_hex_color": "#7E868A",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "psv-silver-dollar": {
          "id": "psv-silver-dollar",
          "name": "EasyPSV\u00ae Silver Dollar",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115304\/psv-silver.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115304\/psv-silver-150x150.png"
          }
        },
        "psv-white-cloud": {
          "id": "psv-white-cloud",
          "name": "EasyPSV\u00ae White Cloud",
          "solid_hex_color": "#E4E9E9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easypsv-application-tape": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easypsv-application-tape",
        "materials": [],
        "name": "EasyPSV\u00ae Application Tape",
        "easypsv-application-tape": {
          "id": "easypsv-application-tape",
          "name": "EasyPSV\u00ae Application Tape",
          "solid_hex_color": "",
          "tile_image_urls": []
        }
      },
      "easypsv-blackboard": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 15,
              "speed": 10
            }
          }
        },
        "id": "easypsv-blackboard",
        "materials": [],
        "name": "EasyPSV\u00ae Blackboard\u00ae",
        "psv-blackboard": {
          "id": "psv-blackboard",
          "name": "EasyPSV\u00ae Blackboard\u00ae",
          "solid_hex_color": "#232323",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easypsv-etch": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easypsv-etch",
        "materials": [],
        "name": "EasyPSV\u00ae Etch",
        "psv-etch": {
          "id": "psv-etch",
          "name": "EasyPSV\u00ae Etch",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12114916\/psv-etch.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12114916\/psv-etch-150x150.png"
          }
        }
      },
      "easypsv-glitter": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 10,
              "speed": 10
            }
          }
        },
        "id": "easypsv-glitter",
        "materials": [],
        "name": "EasyPSV\u00ae Glitter",
        "psv-glitter-rose-gold": {
          "id": "psv-glitter-rose-gold",
          "name": "EasyPSV\u00ae Glitter Rose Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142156\/psv-glitter-rose-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142156\/psv-glitter-rose-gold-150x150.png"
          }
        },
        "psv-glitter-coral": {
          "id": "psv-glitter-coral",
          "name": "EasyPSV\u00ae Glitter Coral",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142435\/psv-glitter-coral.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142435\/psv-glitter-coral-150x150.png"
          }
        },
        "psv-glitter-pink-flirt": {
          "id": "psv-glitter-pink-flirt",
          "name": "EasyPSV\u00ae Glitter Pink Flirt",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142535\/psv-glitter-pink-flirt.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142535\/psv-glitter-pink-flirt-150x150.png"
          }
        },
        "psv-glitter-hyacinth": {
          "id": "psv-glitter-hyacinth",
          "name": "EasyPSV\u00ae Glitter Hyacinth",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142518\/psv-glitter-hyacinth.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142518\/psv-glitter-hyacinth-150x150.png"
          }
        },
        "psv-glitter-midnight-violet": {
          "id": "psv-glitter-midnight-violet",
          "name": "EasyPSV\u00ae Glitter Midnight Violet",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142527\/psv-glitter-midnight-violet.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142527\/psv-glitter-midnight-violet-150x150.png"
          }
        },
        "psv-glitter-marine-blue": {
          "id": "psv-glitter-marine-blue",
          "name": "EasyPSV\u00ae Glitter Marine Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142524\/psv-glitter-marine-blue.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142524\/psv-glitter-marine-blue-150x150.png"
          }
        },
        "psv-glitter-lapis-blue": {
          "id": "psv-glitter-lapis-blue",
          "name": "EasyPSV\u00ae Glitter Lapis Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142521\/psv-glitter-lapis-blue.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142521\/psv-glitter-lapis-blue-150x150.png"
          }
        },
        "psv-glitter-azurite": {
          "id": "psv-glitter-azurite",
          "name": "EasyPSV\u00ae Glitter Azurite",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142458\/psv-glitter-azurite.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142458\/psv-glitter-azurite-150x150.png"
          }
        },
        "psv-glitter-sparkling-aqua": {
          "id": "psv-glitter-sparkling-aqua",
          "name": "EasyPSV\u00ae Glitter Sparkling Aqua",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30143109\/psv-glitter-sparkling-aqua.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30143109\/psv-glitter-sparkling-aqua-150x150.png"
          }
        },
        "psv-glitter-emerald-envy": {
          "id": "psv-glitter-emerald-envy",
          "name": "EasyPSV\u00ae Glitter Emerald Envy",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142510\/psv-glitter-emerald-envy.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142510\/psv-glitter-emerald-envy-150x150.png"
          }
        },
        "psv-glitter-glimmering-gold": {
          "id": "psv-glitter-glimmering-gold",
          "name": "EasyPSV\u00ae Glitter Glimmering Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142515\/psv-glitter-glimmering-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142515\/psv-glitter-glimmering-gold-150x150.png"
          }
        },
        "psv-glitter-brick-red": {
          "id": "psv-glitter-brick-red",
          "name": "EasyPSV\u00ae Glitter Brick Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142501\/psv-glitter-brick-red.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142501\/psv-glitter-brick-red-150x150.png"
          }
        },
        "psv-glitter-flame-red": {
          "id": "psv-glitter-flame-red",
          "name": "EasyPSV\u00ae Glitter Flame Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142512\/psv-glitter-flame-red.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142512\/psv-glitter-flame-red-150x150.png"
          }
        },
        "psv-glitter-night-sky": {
          "id": "psv-glitter-night-sky",
          "name": "EasyPSV\u00ae Glitter Night Sky",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142531\/psv-glitter-night-sky.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142531\/psv-glitter-night-sky-150x150.png"
          }
        },
        "psv-glitter-castlerock": {
          "id": "psv-glitter-castlerock",
          "name": "EasyPSV\u00ae Glitter Castlerock",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142504\/psv-glitter-castlerock.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142504\/psv-glitter-castlerock-150x150.png"
          }
        },
        "psv-glitter-diamond": {
          "id": "psv-glitter-diamond",
          "name": "EasyPSV\u00ae Glitter Diamond",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142507\/psv-glitter-diamond.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30142507\/psv-glitter-diamond-150x150.png"
          }
        },
        "psv-glitter-stardust": {
          "id": "psv-glitter-stardust",
          "name": "EasyPSV\u00ae Glitter Stardust",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30143112\/psv-glitter-stardust.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30143112\/psv-glitter-stardust-150x150.png"
          }
        }
      },
      "easypsv-glow": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 10,
              "speed": 10
            }
          }
        },
        "id": "easypsv-glow",
        "materials": [],
        "name": "EasyPSV\u00ae Glow",
        "psv-glow": {
          "id": "psv-glow",
          "name": "EasyPSV\u00ae Permanent Glow",
          "solid_hex_color": "#EDF2C7",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easypsv-holographic": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 10,
              "speed": 10
            }
          }
        },
        "id": "easypsv-holographic",
        "materials": [],
        "name": "EasyPSV\u00ae Holographic",
        "psv-holo-moonlight-pearl": {
          "id": "psv-holo-moonlight-pearl",
          "name": "EasyPSV\u00ae Holographic Moonlight Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111437\/holo-moonlit-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111437\/holo-moonlit-pearl-150x150.jpeg"
          }
        },
        "psv-holo-rainforest-pearl": {
          "id": "psv-holo-rainforest-pearl",
          "name": "EasyPSV\u00ae Holographic Rainforest Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainforest-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainforest-pearl-150x150.jpeg"
          }
        },
        "psv-holo-tropical-pearl": {
          "id": "psv-holo-tropical-pearl",
          "name": "EasyPSV\u00ae Holographic Tropical Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111448\/holo-tropical-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111448\/holo-tropical-pearl-150x150.jpeg"
          }
        },
        "psv-holo-mystic-pearl": {
          "id": "psv-holo-mystic-pearl",
          "name": "EasyPSV\u00ae Holographic Mystic Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111438\/holo-mystic-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111438\/holo-mystic-pearl-150x150.jpeg"
          }
        },
        "psv-holo-pearl": {
          "id": "psv-holo-pearl",
          "name": "EasyPSV\u00ae Holographic Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111442\/holo-rainbow-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111442\/holo-rainbow-pearl-150x150.jpeg"
          }
        },
        "psv-holo-firelit-pearl": {
          "id": "psv-holo-firelit-pearl",
          "name": "EasyPSV\u00ae Holographic Firelit Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111432\/holo-firelit-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111432\/holo-firelit-pearl-150x150.jpeg"
          }
        }
      },
      "easypsv-patterns": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 10,
              "speed": 10
            }
          }
        },
        "id": "easypsv-patterns",
        "materials": [],
        "name": "EasyPSV\u00ae Patterns",
        "psv-mood-ring": {
          "id": "psv-mood-ring",
          "name": "EasyPSV\u00ae Patterns Mood Ring",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/01101542\/Mood-Ring_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/01101542\/Mood-Ring_Tile-150x150.jpg"
          }
        },
        "psv-kuba-cloth": {
          "id": "psv-kuba-cloth",
          "name": "EasyPSV\u00ae Patterns Kuba Cloth",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144851\/Kuba-Cloth_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144851\/Kuba-Cloth_Tile-150x150.jpg"
          }
        },
        "psv-grunge": {
          "id": "psv-grunge",
          "name": "EasyPSV\u00ae Patterns Grunge",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144833\/Grunge_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144833\/Grunge_Tile-150x150.jpg"
          }
        },
        "psv-tie-dye": {
          "id": "psv-tie-dye",
          "name": "EasyPSV\u00ae Patterns Tie Dye",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144916\/Tie-Dye_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144916\/Tie-Dye_Tile-150x150.jpg"
          }
        },
        "psv-terrazzo": {
          "id": "psv-terrazzo",
          "name": "EasyPSV\u00ae Patterns Terrazzo",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144913\/Terrazzo_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144913\/Terrazzo_Tile-150x150.jpg"
          }
        },
        "psv-tortoise-shell": {
          "id": "psv-tortoise-shell",
          "name": "EasyPSV\u00ae Patterns Tortoise Shell",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144918\/Tortoise-Shell_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144918\/Tortoise-Shell_Tile-150x150.jpg"
          }
        },
        "psv-ocean-waves": {
          "id": "psv-ocean-waves",
          "name": "EasyPSV\u00ae Patterns Ocean Waves",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144905\/Ocean-Waves_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144905\/Ocean-Waves_Tile-150x150.jpg"
          }
        },
        "psv-carbon-fiber": {
          "id": "psv-carbon-fiber",
          "name": "EasyPSV\u00ae Patterns Carbon Fiber",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144827\/Carbon-Fiber_Tile-1.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144827\/Carbon-Fiber_Tile-1.jpg"
          }
        },
        "psv-watercolor-rainbow": {
          "id": "psv-watercolor-rainbow",
          "name": "EasyPSV\u00ae Patterns Watercolor Rainbow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144925\/Watercolor-Rainbow_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144925\/Watercolor-Rainbow_Tile-150x150.jpg"
          }
        },
        "psv-vintage-rose": {
          "id": "psv-vintage-rose",
          "name": "EasyPSV\u00ae Patterns Vintage Rose",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144921\/Vintage-Rose_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144921\/Vintage-Rose_Tile-150x150.jpg"
          }
        },
        "psv-tropical-leaves": {
          "id": "psv-tropical-leaves",
          "name": "EasyPSV\u00ae Patterns Tropical Leaves",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144920\/Tropical-Leaves_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144920\/Tropical-Leaves_Tile-150x150.jpg"
          }
        },
        "psv-sunset-gradient": {
          "id": "psv-sunset-gradient",
          "name": "EasyPSV\u00ae Patterns Sunset Gradient",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144912\/Sunset-Gradient_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144912\/Sunset-Gradient_Tile-150x150.jpg"
          }
        },
        "psv-serape": {
          "id": "psv-serape",
          "name": "EasyPSV\u00ae Patterns Serape",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144910\/Serape_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144910\/Serape_Tile-150x150.jpg"
          }
        },
        "psv-paisley-party": {
          "id": "psv-paisley-party",
          "name": "EasyPSV\u00ae Patterns Paisley Party",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144907\/Paisley-Party_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144907\/Paisley-Party_Tile-150x150.jpg"
          }
        },
        "psv-mermaid-scales": {
          "id": "psv-mermaid-scales",
          "name": "EasyPSV\u00ae Patterns Mermaid Scales",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144857\/Mermaid-Scales_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144857\/Mermaid-Scales_Tile-150x150.jpg"
          }
        },
        "psv-leopard-tan": {
          "id": "psv-leopard-tan",
          "name": "EasyPSV\u00ae Patterns Leopard Tan",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/01101531\/Leopard-Tan_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/01101531\/Leopard-Tan_Tile-150x150.jpg"
          }
        },
        "psv-kente": {
          "id": "psv-kente",
          "name": "EasyPSV\u00ae Patterns Kente",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/31091034\/Kente_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/31091034\/Kente_Tile-150x150.jpg"
          }
        },
        "psv-jambo": {
          "id": "psv-jambo",
          "name": "EasyPSV\u00ae Patterns Jambo",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144849\/Jambo_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144849\/Jambo_Tile-150x150.jpg"
          }
        },
        "psv-infinite-galaxy": {
          "id": "psv-infinite-galaxy",
          "name": "EasyPSV\u00ae Patterns Infinite Galaxy",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144845\/Infinite-Galaxy_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144845\/Infinite-Galaxy_Tile-150x150.jpg"
          }
        },
        "psv-camo-green": {
          "id": "psv-camo-green",
          "name": "EasyPSV\u00ae Patterns Camo Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144826\/Camo-Green_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144826\/Camo-Green_Tile-150x150.jpg"
          }
        },
        "psv-buffalo-plaid-red": {
          "id": "psv-buffalo-plaid-red",
          "name": "EasyPSV\u00ae Patterns Buffalo Plaid Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144819\/Buffalo-Plaid-Red_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144819\/Buffalo-Plaid-Red_Tile.jpg"
          }
        },
        "psv-watercolor-plaid": {
          "id": "psv-watercolor-plaid",
          "name": "EasyPSV\u00ae Patterns Watercolor Plaid",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144923\/Watercolor-Plaid_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144923\/Watercolor-Plaid_Tile-150x150.jpg"
          }
        },
        "psv-bohemian-stripes": {
          "id": "psv-bohemian-stripes",
          "name": "EasyPSV\u00ae Patterns Bohemian Stripes",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144818\/Bohemian-Stripes_Tile.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/30144818\/Bohemian-Stripes_Tile-150x150.jpg"
          }
        }
      },
      "easypsv-printable-decal-vinyl": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 10,
              "speed": 10
            }
          }
        },
        "id": "easypsv-printable-decal-vinyl",
        "materials": [],
        "name": "EasyPSV\u00ae Printable (Decal Vinyl)",
        "easypsv-printable": {
          "id": "easypsv-printable",
          "name": "EasyPSV\u00ae Printable",
          "solid_hex_color": "#e5e5e5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easypsv-starling": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easypsv-starling",
        "materials": [],
        "name": "EasyPSV\u00ae Starling",
        "starling-seaglass": {
          "id": "starling-seaglass",
          "name": "EasyPSV\u00ae Starling\u2122 Sea Glass",
          "solid_hex_color": "#64CCC9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-mocha": {
          "id": "starling-mocha",
          "name": "EasyPSV\u00ae Starling\u2122 Mocha",
          "solid_hex_color": "#713F2A",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-light-apricot": {
          "id": "starling-light-apricot",
          "name": "EasyPSV\u00ae Starling\u2122 Light Apricot",
          "solid_hex_color": "#F3CFB3",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-mustard": {
          "id": "starling-mustard",
          "name": "EasyPSV\u00ae Starling\u2122 Mustard",
          "solid_hex_color": "#F4AF23",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-latte": {
          "id": "starling-latte",
          "name": "EasyPSV\u00ae Starling\u2122 Latte",
          "solid_hex_color": "#bd8770",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-cashew": {
          "id": "starling-cashew",
          "name": "EasyPSV\u00ae Starling\u2122 Cashew",
          "solid_hex_color": "#D9B48F",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-sage": {
          "id": "starling-sage",
          "name": "EasyPSV\u00ae Starling\u2122 Sage",
          "solid_hex_color": "#A8D5BA",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-periwinkle": {
          "id": "starling-periwinkle",
          "name": "EasyPSV\u00ae Starling\u2122 Periwinkle",
          "solid_hex_color": "#98B6E4",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-hazelnut": {
          "id": "starling-hazelnut",
          "name": "EasyPSV\u00ae Starling\u2122 Hazelnut",
          "solid_hex_color": "#9A5F3A",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-pale-peach": {
          "id": "starling-pale-peach",
          "name": "EasyPSV\u00ae Starling\u2122 Pale Peach",
          "solid_hex_color": "#EABEB0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-flamingo": {
          "id": "starling-flamingo",
          "name": "EasyPSV\u00ae Starling\u2122 Flamingo",
          "solid_hex_color": "#F8A3BC",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-retro-mint": {
          "id": "starling-retro-mint",
          "name": "EasyPSV\u00ae Starling\u2122 Retro Mint",
          "solid_hex_color": "#3CDBC0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-green-olive": {
          "id": "starling-green-olive",
          "name": "EasyPSV\u00ae Starling\u2122 Green Olive",
          "solid_hex_color": "#5E6738",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-pumpkin-pie": {
          "id": "starling-pumpkin-pie",
          "name": "EasyPSV\u00ae Starling\u2122 Pumpkin Pie",
          "solid_hex_color": "#A65523",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-lime": {
          "id": "starling-lime",
          "name": "EasyPSV\u00ae Starling\u2122 Lime Green",
          "solid_hex_color": "#93DA49",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-dark-beige": {
          "id": "starling-dark-beige",
          "name": "EasyPSV\u00ae Starling\u2122 Dark Beige",
          "solid_hex_color": "#DFD3BB",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-bronze": {
          "id": "starling-bronze",
          "name": "EasyPSV\u00ae Starling\u2122 Bronze",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-rose-gold": {
          "id": "starling-rose-gold",
          "name": "EasyPSV\u00ae Starling\u2122 Rose Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115157\/psv-rose-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115157\/psv-rose-gold-150x150.png"
          }
        },
        "starling-tropical-pink": {
          "id": "starling-tropical-pink",
          "name": "EasyPSV\u00ae Starling\u2122 Tropical Pink",
          "solid_hex_color": "#E0457B",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-carnation-pink": {
          "id": "starling-carnation-pink",
          "name": "EasyPSV\u00ae Starling\u2122 Carnation Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-cherry-blossom-pink": {
          "id": "starling-cherry-blossom-pink",
          "name": "EasyPSV\u00ae Starling\u2122 Cherry Blossom Pink",
          "solid_hex_color": "#F2C6CF",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-light-orchid": {
          "id": "starling-light-orchid",
          "name": "EasyPSV\u00ae Starling\u2122 Light Orchid",
          "solid_hex_color": "#C6A1CF",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-wisteria": {
          "id": "starling-wisteria",
          "name": "EasyPSV\u00ae Starling\u2122 Wisteria",
          "solid_hex_color": "#7965B2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-violet": {
          "id": "starling-violet",
          "name": "EasyPSV\u00ae Starling\u2122 Violet",
          "solid_hex_color": "#5D4777",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-royal-purple": {
          "id": "starling-royal-purple",
          "name": "EasyPSV\u00ae Starling\u2122 Royal Purple",
          "solid_hex_color": "#33058D",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-twilight-navy": {
          "id": "starling-twilight-navy",
          "name": "EasyPSV\u00ae Starling\u2122 Twilight Navy",
          "solid_hex_color": "#002E5D",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-soft-blue": {
          "id": "starling-soft-blue",
          "name": "EasyPSV\u00ae Starling\u2122 Soft Blue",
          "solid_hex_color": "#B1C9E8",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-cobalt": {
          "id": "starling-cobalt",
          "name": "EasyPSV\u00ae Starling\u2122 Cobalt",
          "solid_hex_color": "#303AB2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-nautical-blue": {
          "id": "starling-nautical-blue",
          "name": "EasyPSV\u00ae Starling\u2122 Nautical Blue",
          "solid_hex_color": "#004986",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-blue-skies": {
          "id": "starling-blue-skies",
          "name": "EasyPSV\u00ae Starling\u2122 Blue Skies",
          "solid_hex_color": "#41B6E6",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-totally-teal": {
          "id": "starling-totally-teal",
          "name": "EasyPSV\u00ae Starling\u2122 Totally Teal",
          "solid_hex_color": "#00859B",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-aqua": {
          "id": "starling-aqua",
          "name": "EasyPSV\u00ae Starling\u2122 Aqua",
          "solid_hex_color": "#00B2A9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-fresh-mint": {
          "id": "starling-fresh-mint",
          "name": "EasyPSV\u00ae Starling\u2122 Fresh Mint",
          "solid_hex_color": "#A7E6D7",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-emerald": {
          "id": "starling-emerald",
          "name": "EasyPSV\u00ae Starling\u2122 Emerald",
          "solid_hex_color": "#006F44",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-turtle-green": {
          "id": "starling-turtle-green",
          "name": "EasyPSV\u00ae Starling\u2122 Turtle Green",
          "solid_hex_color": "#154734",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-bright-green": {
          "id": "starling-bright-green",
          "name": "EasyPSV\u00ae Starling\u2122 Bright Green",
          "solid_hex_color": "#6CC24A",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-alligator-green": {
          "id": "starling-alligator-green",
          "name": "EasyPSV\u00ae Starling\u2122 Alligator Green",
          "solid_hex_color": "#79863C",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-citrus": {
          "id": "starling-citrus",
          "name": "EasyPSV\u00ae Starling\u2122 Citrus",
          "solid_hex_color": "#E0E722",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-canary": {
          "id": "starling-canary",
          "name": "EasyPSV\u00ae Starling\u2122 Canary Yellow",
          "solid_hex_color": "#ffe81d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-dandelion": {
          "id": "starling-dandelion",
          "name": "EasyPSV\u00ae Starling\u2122 Dandelion",
          "solid_hex_color": "#F6BE00",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-cream-and-sugar": {
          "id": "starling-cream-and-sugar",
          "name": "EasyPSV\u00ae Starling\u2122 Cream & Sugar",
          "solid_hex_color": "#EFDBB2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-camel": {
          "id": "starling-camel",
          "name": "EasyPSV\u00ae Starling\u2122 Camel",
          "solid_hex_color": "#BD9A7A",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-golden": {
          "id": "starling-golden",
          "name": "EasyPSV\u00ae Starling\u2122 Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115016\/psv-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115016\/psv-gold-150x150.png"
          }
        },
        "starling-coffee": {
          "id": "starling-coffee",
          "name": "EasyPSV\u00ae Starling\u2122 Coffee",
          "solid_hex_color": "#4E3524",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-corel-reef": {
          "id": "starling-corel-reef",
          "name": "EasyPSV\u00ae Starling\u2122 Corel Reef",
          "solid_hex_color": "#F2827F",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-orange-soda": {
          "id": "starling-orange-soda",
          "name": "EasyPSV\u00ae Starling\u2122 Orange Soda",
          "solid_hex_color": "#FF6900",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-orange": {
          "id": "starling-orange",
          "name": "EasyPSV\u00ae Starling\u2122 Orange",
          "solid_hex_color": "#DC4405",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-ketchup": {
          "id": "starling-ketchup",
          "name": "EasyPSV\u00ae Starling\u2122 Ketchup",
          "solid_hex_color": "#CD001A",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-persimmon": {
          "id": "starling-persimmon",
          "name": "EasyPSV\u00ae Starling\u2122 Persimmon",
          "solid_hex_color": "#E10600",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-holly-berry": {
          "id": "starling-holly-berry",
          "name": "EasyPSV\u00ae Starling\u2122 Holly Berry",
          "solid_hex_color": "#Bd3742",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-merlot": {
          "id": "starling-merlot",
          "name": "EasyPSV\u00ae Starling\u2122 Merlot",
          "solid_hex_color": "#782f40",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-black-cat-gloss": {
          "id": "starling-black-cat-gloss",
          "name": "EasyPSV\u00ae Starling\u2122 Black Gloss",
          "solid_hex_color": "#000000",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-black-cat-matte": {
          "id": "starling-black-cat-matte",
          "name": "EasyPSV\u00ae Starling\u2122 Black Matte",
          "solid_hex_color": "#212721",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-graphite": {
          "id": "starling-graphite",
          "name": "EasyPSV\u00ae Starling\u2122 Graphite",
          "solid_hex_color": "#717C7D",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-silver-dollar": {
          "id": "starling-silver-dollar",
          "name": "EasyPSV\u00ae Starling\u2122 Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115304\/psv-silver.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12115304\/psv-silver-150x150.png"
          }
        },
        "starling-white-cloud-gloss": {
          "id": "starling-white-cloud-gloss",
          "name": "EasyPSV\u00ae Starling\u2122 White Gloss",
          "solid_hex_color": "#F0F0F1",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "starling-white-cloud-matte": {
          "id": "starling-white-cloud-matte",
          "name": "EasyPSV\u00ae Starling\u2122 White Matte",
          "solid_hex_color": "#f1f2f0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easy-reflective": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easy-reflective",
        "materials": [],
        "name": "EasyReflective\u00ae",
        "easyreflective-2": {
          "id": "easyreflective-2",
          "name": "EasyReflective\u00ae",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09145948\/web-tile.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09145948\/web-tile-150x150.jpeg"
          }
        }
      },
      "easysubli-htv": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easysubli-htv",
        "materials": [],
        "name": "EasySubli\u00ae HTV",
        "easysubli-htv": {
          "id": "easysubli-htv",
          "name": "EasySubli\u00ae HTV",
          "solid_hex_color": "#e2e2e2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easysubli-mask": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easysubli-mask",
        "materials": [],
        "name": "EasySubli\u00ae Mask",
        "easysubli-mask": {
          "id": "easysubli-mask",
          "name": "EasySubli\u00ae Mask",
          "solid_hex_color": "",
          "tile_image_urls": []
        }
      },
      "easy-puff": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easy-puff",
        "materials": [],
        "name": "Easy\u2122 Puff",
        "easy-puff-beige": {
          "id": "easy-puff-beige",
          "name": "Easy\u2122 Puff Beige",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-deep-pink": {
          "id": "easy-puff-deep-pink",
          "name": "Easy\u2122 Puff Deep Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-dark-gray": {
          "id": "easy-puff-dark-gray",
          "name": "Easy\u2122 Puff Dark Gray",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-forest-green": {
          "id": "easy-puff-forest-green",
          "name": "Easy\u2122 Puff Forest Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-camel": {
          "id": "easy-puff-camel",
          "name": "Easy\u2122 Puff Camel",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-apple-green": {
          "id": "easy-puff-apple-green",
          "name": "Easy\u2122 Puff Apple Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-light-gray": {
          "id": "easy-puff-light-gray",
          "name": "Easy\u2122 Puff Light Gray",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-neon-blue": {
          "id": "easy-puff-neon-blue",
          "name": "Easy\u2122 Puff Neon Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-neon-orange": {
          "id": "easy-puff-neon-orange",
          "name": "Easy\u2122 Puff Neon Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-neon-yellow": {
          "id": "easy-puff-neon-yellow",
          "name": "Easy\u2122 Puff Neon Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-purple": {
          "id": "easy-puff-purple",
          "name": "Easy\u2122 Puff Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-wine": {
          "id": "easy-puff-wine",
          "name": "Easy\u2122 Puff Wine",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-sky": {
          "id": "easy-puff-sky",
          "name": "Easy\u2122 Puff Sky",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-pink": {
          "id": "easy-puff-pink",
          "name": "Easy\u2122 Puff Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-orange": {
          "id": "easy-puff-orange",
          "name": "Easy\u2122 Puff Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-green": {
          "id": "easy-puff-green",
          "name": "Easy\u2122 Puff Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-yellow": {
          "id": "easy-puff-yellow",
          "name": "Easy\u2122 Puff Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-red": {
          "id": "easy-puff-red",
          "name": "Easy\u2122 Puff Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-navy": {
          "id": "easy-puff-navy",
          "name": "Easy\u2122 Puff Navy",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-black": {
          "id": "easy-puff-black",
          "name": "Easy\u2122 Puff Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-white": {
          "id": "easy-puff-white",
          "name": "Easy\u2122 Puff White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easy-weed": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easy-weed",
        "materials": [],
        "name": "EasyWeed\u00ae",
        "ew-fluorescent-blue": {
          "id": "ew-fluorescent-blue",
          "name": "EasyWeed\u00ae Fluorescent Blue",
          "solid_hex_color": "#3260ad",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-green": {
          "id": "ew-fluorescent-green",
          "name": "EasyWeed\u00ae Fluorescent Green",
          "solid_hex_color": "#65bd4d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-yellow": {
          "id": "ew-fluorescent-yellow",
          "name": "EasyWeed\u00ae Fluorescent Yellow",
          "solid_hex_color": "#eae721",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-orange": {
          "id": "ew-fluorescent-orange",
          "name": "EasyWeed\u00ae Fluorescent Orange",
          "solid_hex_color": "#f27a21",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-coral": {
          "id": "ew-fluorescent-coral",
          "name": "EasyWeed\u00ae Fluorescent Coral",
          "solid_hex_color": "#ec2228",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easyweed-fluorescent-raspberry": {
          "id": "easyweed-fluorescent-raspberry",
          "name": "EasyWeed\u00ae Fluorescent Raspberry",
          "solid_hex_color": "#ed1876",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-pink": {
          "id": "ew-fluorescent-pink",
          "name": "EasyWeed\u00ae Fluorescent Pink",
          "solid_hex_color": "#eb2c92",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-light-pink": {
          "id": "ew-light-pink",
          "name": "EasyWeed\u00ae Light Pink",
          "solid_hex_color": "#ecc0c5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-pale-peach": {
          "id": "ew-pale-peach",
          "name": "EasyWeed\u00ae Pale Peach",
          "solid_hex_color": "#edbeab",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-melon": {
          "id": "ew-melon",
          "name": "EasyWeed\u00ae Melon",
          "solid_hex_color": "#f8a89d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-bubblegum": {
          "id": "ew-bubblegum",
          "name": "EasyWeed\u00ae Bubblegum",
          "solid_hex_color": "#e983b2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-pink": {
          "id": "ew-pink",
          "name": "EasyWeed\u00ae Pink",
          "solid_hex_color": "#d91d76",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-passion-pink": {
          "id": "ew-passion-pink",
          "name": "EasyWeed\u00ae Passion Pink",
          "solid_hex_color": "#d31a6b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-lilac": {
          "id": "ew-lilac",
          "name": "EasyWeed\u00ae Lilac",
          "solid_hex_color": "#b995c5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-wicked-purple": {
          "id": "ew-wicked-purple",
          "name": "EasyWeed\u00ae Wicked Purple",
          "solid_hex_color": "#66538a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-purple": {
          "id": "ew-purple",
          "name": "EasyWeed\u00ae Purple",
          "solid_hex_color": "#1b1145",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-navy-blue": {
          "id": "ew-navy-blue",
          "name": "EasyWeed\u00ae Navy Blue",
          "solid_hex_color": "#0d162d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-royal-blue": {
          "id": "ew-royal-blue",
          "name": "EasyWeed\u00ae Royal Blue",
          "solid_hex_color": "#293476",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-periwinkle": {
          "id": "ew-periwinkle",
          "name": "EasyWeed\u00ae Periwinkle",
          "solid_hex_color": "#98c4e1",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-pale-blue": {
          "id": "ew-pale-blue",
          "name": "EasyWeed\u00ae Pale Blue",
          "solid_hex_color": "#9fb3d9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-sky-blue": {
          "id": "ew-sky-blue",
          "name": "EasyWeed\u00ae Sky Blue",
          "solid_hex_color": "#1472b9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-powder-blue": {
          "id": "ew-powder-blue",
          "name": "EasyWeed\u00ae Powder Blue",
          "solid_hex_color": "#bfcdd7",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-turquoise": {
          "id": "ew-turquoise",
          "name": "EasyWeed\u00ae Turquoise",
          "solid_hex_color": "#01506d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-retro-mint": {
          "id": "ew-retro-mint",
          "name": "EasyWeed\u00ae Retro Mint",
          "solid_hex_color": "#66c6b9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-dark-green": {
          "id": "ew-dark-green",
          "name": "EasyWeed\u00ae Dark Green",
          "solid_hex_color": "#16281b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-green-olive": {
          "id": "ew-green-olive",
          "name": "EasyWeed\u00ae Green Olive",
          "solid_hex_color": "#67704a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-sage": {
          "id": "ew-sage",
          "name": "EasyWeed\u00ae Sage",
          "solid_hex_color": "#a8cbb5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-cadette-green": {
          "id": "ew-cadette-green",
          "name": "EasyWeed\u00ae Cadette Green",
          "solid_hex_color": "#198965",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-green": {
          "id": "ew-green",
          "name": "EasyWeed\u00ae Green",
          "solid_hex_color": "#00704a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-green-apple": {
          "id": "ew-green-apple",
          "name": "EasyWeed\u00ae Green Apple",
          "solid_hex_color": "#6eb94d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-lime": {
          "id": "ew-lime",
          "name": "EasyWeed\u00ae Lime",
          "solid_hex_color": "#c5d92e",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-mocha": {
          "id": "ew-mocha",
          "name": "EasyWeed\u00ae Mocha",
          "solid_hex_color": "#7b5646",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-chocolate": {
          "id": "ew-chocolate",
          "name": "EasyWeed\u00ae Chocolate",
          "solid_hex_color": "#875422",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-hazelnut": {
          "id": "ew-hazelnut",
          "name": "EasyWeed\u00ae Hazelnut",
          "solid_hex_color": "#9d6c59",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-latte": {
          "id": "ew-latte",
          "name": "EasyWeed\u00ae Latte",
          "solid_hex_color": "#b38674",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-tan": {
          "id": "ew-tan",
          "name": "EasyWeed\u00ae Tan",
          "solid_hex_color": "#ce9862",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-cashew": {
          "id": "ew-cashew",
          "name": "EasyWeed\u00ae Cashew",
          "solid_hex_color": "#d1ab8c",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-light-apricot": {
          "id": "ew-light-apricot",
          "name": "EasyWeed\u00ae Light Apricot",
          "solid_hex_color": "#f8cba6",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-cream": {
          "id": "ew-cream",
          "name": "EasyWeed\u00ae Cream",
          "solid_hex_color": "#eacc9d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-vegas-gold": {
          "id": "ew-vegas-gold",
          "name": "EasyWeed\u00ae Vegas Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094409\/ew-vegas-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094409\/ew-vegas-gold-150x150.png"
          }
        },
        "ew-gold": {
          "id": "ew-gold",
          "name": "EasyWeed\u00ae Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094059\/ew-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094059\/ew-gold-150x150.png"
          }
        },
        "ew-lemon": {
          "id": "ew-lemon",
          "name": "EasyWeed\u00ae Lemon",
          "solid_hex_color": "#f6dd05",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-yellow": {
          "id": "ew-yellow",
          "name": "EasyWeed\u00ae Yellow",
          "solid_hex_color": "#ffb401",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-sun": {
          "id": "ew-sun",
          "name": "EasyWeed\u00ae Sun",
          "solid_hex_color": "#faa51b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-mustard": {
          "id": "ew-mustard",
          "name": "EasyWeed\u00ae Mustard",
          "solid_hex_color": "#e2a035",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-orange-soda": {
          "id": "ew-orange-soda",
          "name": "EasyWeed\u00ae Orange Soda",
          "solid_hex_color": "#f37137",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-orange": {
          "id": "ew-orange",
          "name": "EasyWeed\u00ae Orange",
          "solid_hex_color": "#f04c25",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-texas-orange": {
          "id": "ew-texas-orange",
          "name": "EasyWeed\u00ae Texas Orange",
          "solid_hex_color": "#b73326",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-cardinal": {
          "id": "ew-cardinal",
          "name": "EasyWeed\u00ae Cardinal",
          "solid_hex_color": "#87181a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-hibiscus": {
          "id": "ew-hibiscus",
          "name": "EasyWeed\u00ae Hibiscus",
          "solid_hex_color": "#ee343d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-red": {
          "id": "ew-red",
          "name": "EasyWeed\u00ae Red",
          "solid_hex_color": "#c62127",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-burgundy": {
          "id": "ew-burgundy",
          "name": "EasyWeed\u00ae Burgundy",
          "solid_hex_color": "#8a1824",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-maroon": {
          "id": "ew-maroon",
          "name": "EasyWeed\u00ae Maroon",
          "solid_hex_color": "#54313a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-dark-maroon": {
          "id": "ew-dark-maroon",
          "name": "EasyWeed\u00ae Dark Maroon",
          "solid_hex_color": "#381a26",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-brown": {
          "id": "ew-brown",
          "name": "EasyWeed\u00ae Brown",
          "solid_hex_color": "#3d1916",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-black": {
          "id": "ew-black",
          "name": "EasyWeed\u00ae Black",
          "solid_hex_color": "#0b0b0b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-charcoal": {
          "id": "ew-charcoal",
          "name": "EasyWeed\u00ae Charcoal",
          "solid_hex_color": "#43424b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-gray": {
          "id": "ew-gray",
          "name": "EasyWeed\u00ae Gray",
          "solid_hex_color": "#959191",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-bright-red": {
          "id": "ew-bright-red",
          "name": "EasyWeed\u00ae Bright Red",
          "solid_hex_color": "#e02028",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-flamingo": {
          "id": "ew-flamingo",
          "name": "EasyWeed\u00ae Flamingo",
          "solid_hex_color": "#f09daf",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-silver": {
          "id": "ew-silver",
          "name": "EasyWeed\u00ae Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/12100513\/ew-silver.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/12100513\/ew-silver-150x150.png"
          }
        },
        "ew-white": {
          "id": "ew-white",
          "name": "EasyWeed\u00ae White",
          "solid_hex_color": "#ffffff",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "easyweed-adhesive": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easyweed-adhesive",
        "materials": [],
        "name": "EasyWeed\u00ae Adhesive",
        "ew-adhesive": {
          "id": "ew-adhesive",
          "name": "EasyWeed\u00ae Adhesive",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/14084847\/ew-adhesive.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/14084847\/ew-adhesive-150x150.jpeg"
          }
        }
      },
      "easyweed-electric": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easyweed-electric",
        "materials": [],
        "name": "EasyWeed\u00ae Electric",
        "electric-gold-lens": {
          "id": "electric-gold-lens",
          "name": "EasyWeed\u00ae\u00a0Electric Gold Lens",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143628\/electric-gold-lens.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143628\/electric-gold-lens-150x150.jpeg"
          }
        },
        "electric-silver-lens": {
          "id": "electric-silver-lens",
          "name": "EasyWeed\u00ae\u00a0Electric Silver Lens",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143642\/electric-silver-lens.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143642\/electric-silver-lens-150x150.jpeg"
          }
        },
        "electric-rose-gold": {
          "id": "electric-rose-gold",
          "name": "EasyWeed\u00ae\u00a0Electric Rose Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143641\/electric-rose-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143641\/electric-rose-gold-150x150.jpeg"
          }
        },
        "electric-pink": {
          "id": "electric-pink",
          "name": "EasyWeed\u00ae\u00a0Electric Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143637\/electric-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143637\/electric-pink-150x150.jpeg"
          }
        },
        "electric-cherry": {
          "id": "electric-cherry",
          "name": "EasyWeed\u00ae\u00a0Electric Cherry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143622\/electric-cherry.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143622\/electric-cherry-150x150.jpeg"
          }
        },
        "electric-purple": {
          "id": "electric-purple",
          "name": "EasyWeed\u00ae\u00a0Electric Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143638\/electric-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143638\/electric-purple-150x150.jpeg"
          }
        },
        "electric-grape": {
          "id": "electric-grape",
          "name": "EasyWeed\u00ae\u00a0Electric Grape",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143629\/electric-grape.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143629\/electric-grape-150x150.jpeg"
          }
        },
        "electric-frosted-blueberry": {
          "id": "electric-frosted-blueberry",
          "name": "EasyWeed\u00ae\u00a0Electric Frosted Blueberry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143627\/electric-frosted-blueberry.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143627\/electric-frosted-blueberry-150x150.jpeg"
          }
        },
        "electric-columbia-blue": {
          "id": "electric-columbia-blue",
          "name": "EasyWeed\u00ae\u00a0Electric Columbia Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143623\/electric-columbian-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143623\/electric-columbian-blue-150x150.jpeg"
          }
        },
        "electric-blue": {
          "id": "electric-blue",
          "name": "EasyWeed\u00ae\u00a0Electric Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143621\/electric-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143621\/electric-blue-150x150.jpeg"
          }
        },
        "electric-spearmint": {
          "id": "electric-spearmint",
          "name": "EasyWeed\u00ae\u00a0Electric Spearmint",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143642\/electric-spearmint.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143642\/electric-spearmint-150x150.jpeg"
          }
        },
        "electric-peacock-teal": {
          "id": "electric-peacock-teal",
          "name": "EasyWeed\u00ae\u00a0Electric Peacock Teal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143635\/electric-peacock-teal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143635\/electric-peacock-teal-150x150.jpeg"
          }
        },
        "electric-teal": {
          "id": "electric-teal",
          "name": "EasyWeed\u00ae\u00a0Electric Teal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143644\/electric-teal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143644\/electric-teal-150x150.jpeg"
          }
        },
        "easyweed-electric-olive": {
          "id": "easyweed-electric-olive",
          "name": "EasyWeed\u00ae\u00a0Electric Olive",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143632\/electric-olive.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143632\/electric-olive-150x150.jpeg"
          }
        },
        "electric-green": {
          "id": "electric-green",
          "name": "EasyWeed\u00ae\u00a0Electric Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143630\/electric-green.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143630\/electric-green-150x150.jpg"
          }
        },
        "easyweed-electric-lime": {
          "id": "easyweed-electric-lime",
          "name": "EasyWeed\u00ae\u00a0Electric Lime",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143631\/electric-lime.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143631\/electric-lime-150x150.jpeg"
          }
        },
        "electric-yellow": {
          "id": "electric-yellow",
          "name": "EasyWeed\u00ae\u00a0Electric Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143647\/electric-yellow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143647\/electric-yellow-150x150.jpeg"
          }
        },
        "easyweed-electric-orange": {
          "id": "easyweed-electric-orange",
          "name": "EasyWeed\u00ae\u00a0Electric Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143634\/electric-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143634\/electric-orange-150x150.jpeg"
          }
        },
        "electric-red": {
          "id": "electric-red",
          "name": "EasyWeed\u00ae\u00a0Electric Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143639\/electric-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143639\/electric-red-150x150.jpeg"
          }
        },
        "electric-cranberry": {
          "id": "electric-cranberry",
          "name": "EasyWeed\u00ae\u00a0Electric Cranberry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143626\/electric-cranberry.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143626\/electric-cranberry-150x150.jpg"
          }
        },
        "electric-copper": {
          "id": "electric-copper",
          "name": "EasyWeed\u00ae\u00a0Electric Copper",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143625\/electric-copper.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143625\/electric-copper-150x150.jpeg"
          }
        },
        "electric-tungsten": {
          "id": "electric-tungsten",
          "name": "EasyWeed\u00ae\u00a0Electric Tungsten",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143645\/electric-tungsten.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143645\/electric-tungsten-150x150.jpeg"
          }
        },
        "electric-white-opal": {
          "id": "electric-white-opal",
          "name": "EasyWeed\u00ae\u00a0Electric White Opal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143646\/electric-white-opal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143646\/electric-white-opal-150x150.jpeg"
          }
        },
        "electric-pearl": {
          "id": "electric-pearl",
          "name": "EasyWeed\u00ae\u00a0Electric Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143636\/electric-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143636\/electric-pearl-150x150.jpeg"
          }
        }
      },
      "easyweed-extra": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easyweed-extra",
        "materials": [],
        "name": "EasyWeed\u00ae Extra",
        "extra-black": {
          "id": "extra-black",
          "name": "EasyWeed\u00ae Extra Black",
          "solid_hex_color": "#050505",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "extra-white": {
          "id": "extra-white",
          "name": "EasyWeed\u00ae Extra White",
          "solid_hex_color": "#ffffff",
          "tile_image_urls": []
        }
      },
      "easyweed-glow": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easyweed-glow",
        "materials": [],
        "name": "EasyWeed\u00ae Glow",
        "ew-glow": {
          "id": "ew-glow",
          "name": "EasyWeed\u00ae Glow in the Dark",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/12100637\/Glow-In-the-Dark.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/12100637\/Glow-In-the-Dark-150x150.png"
          }
        }
      },
      "easyweed-stretch": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easyweed-stretch",
        "materials": [],
        "name": "EasyWeed\u00ae Stretch",
        "stretch-rose-gold": {
          "id": "stretch-rose-gold",
          "name": "EasyWeed\u00ae Stretch Rose Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12095542\/stretch-rose-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12095542\/stretch-rose-gold-150x150.png"
          }
        },
        "stretch-ballerina-pink": {
          "id": "stretch-ballerina-pink",
          "name": "EasyWeed\u00ae Stretch Ballerina Pink",
          "solid_hex_color": "#fdded0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-coral": {
          "id": "stretch-coral",
          "name": "EasyWeed\u00ae Stretch Coral",
          "solid_hex_color": "#f68683",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-bubblegum": {
          "id": "stretch-bubblegum",
          "name": "EasyWeed\u00ae Stretch Bubblegum",
          "solid_hex_color": "#fb7ea8",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-passion-pink": {
          "id": "stretch-passion-pink",
          "name": "EasyWeed\u00ae Stretch Passion Pink",
          "solid_hex_color": "#d91e76",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-bright-orchid": {
          "id": "stretch-bright-orchid",
          "name": "EasyWeed\u00ae Stretch Bright Orchid",
          "solid_hex_color": "#cd73ab",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-purple-berry": {
          "id": "stretch-purple-berry",
          "name": "EasyWeed\u00ae Stretch Purple Berry",
          "solid_hex_color": "#8a1ca3",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-lilac": {
          "id": "stretch-lilac",
          "name": "EasyWeed\u00ae Stretch Lilac",
          "solid_hex_color": "#c9b3da",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-wisteria": {
          "id": "stretch-wisteria",
          "name": "EasyWeed\u00ae Stretch Wisteria",
          "solid_hex_color": "#8674ad",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-royal-purple": {
          "id": "stretch-royal-purple",
          "name": "EasyWeed\u00ae Stretch Royal Purple",
          "solid_hex_color": "#4f4696",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-cobalt-blue": {
          "id": "stretch-cobalt-blue",
          "name": "EasyWeed\u00ae Stretch Cobalt Blue",
          "solid_hex_color": "#33429f",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-navy-blue": {
          "id": "stretch-navy-blue",
          "name": "EasyWeed\u00ae Stretch Navy Blue",
          "solid_hex_color": "#08132b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-royal-blue": {
          "id": "stretch-royal-blue",
          "name": "EasyWeed\u00ae Stretch Royal Blue",
          "solid_hex_color": "#01237d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-celestial-blue": {
          "id": "stretch-celestial-blue",
          "name": "EasyWeed\u00ae Stretch Celestial Blue",
          "solid_hex_color": "#0197df",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-pale-blue": {
          "id": "stretch-pale-blue",
          "name": "EasyWeed\u00ae Stretch Pale Blue",
          "solid_hex_color": "#6bcaf2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-frosty-mint": {
          "id": "stretch-frosty-mint",
          "name": "EasyWeed\u00ae Stretch Frosty Mint",
          "solid_hex_color": "#a6e1e7",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-totally-teal": {
          "id": "stretch-totally-teal",
          "name": "EasyWeed\u00ae Stretch Totally Teal",
          "solid_hex_color": "#0198a5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-sea-glass": {
          "id": "stretch-sea-glass",
          "name": "EasyWeed\u00ae Stretch Sea Glass",
          "solid_hex_color": "#7dd6d0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-sweet-mint": {
          "id": "stretch-sweet-mint",
          "name": "EasyWeed\u00ae Stretch Sweet Mint",
          "solid_hex_color": "#affbd5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-green": {
          "id": "stretch-green",
          "name": "EasyWeed\u00ae Stretch Green",
          "solid_hex_color": "#016e49",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-pine-green": {
          "id": "stretch-pine-green",
          "name": "EasyWeed\u00ae Stretch Pine Green",
          "solid_hex_color": "#28544a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-dark-gold": {
          "id": "stretch-dark-gold",
          "name": "EasyWeed\u00ae Stretch Dark Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094940\/stretch-dark-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094940\/stretch-dark-gold-150x150.png"
          }
        },
        "stretch-gold": {
          "id": "stretch-gold",
          "name": "EasyWeed\u00ae Stretch Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094801\/stretch-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094801\/stretch-gold-150x150.png"
          }
        },
        "stretch-lemon": {
          "id": "stretch-lemon",
          "name": "EasyWeed\u00ae Stretch Lemon",
          "solid_hex_color": "#fee801",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-yellow": {
          "id": "stretch-yellow",
          "name": "EasyWeed\u00ae Stretch Yellow",
          "solid_hex_color": "#ffb401",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-sun": {
          "id": "stretch-sun",
          "name": "EasyWeed\u00ae Stretch Sun",
          "solid_hex_color": "#ffa600",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-orange": {
          "id": "stretch-orange",
          "name": "EasyWeed\u00ae Stretch Orange",
          "solid_hex_color": "#f94801",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-calypso-coral": {
          "id": "stretch-calypso-coral",
          "name": "EasyWeed\u00ae Stretch Calypso Coral",
          "solid_hex_color": "#fe6b61",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-coffee": {
          "id": "stretch-coffee",
          "name": "EasyWeed\u00ae Stretch Coffee",
          "solid_hex_color": "#786153",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-chestnut": {
          "id": "stretch-chestnut",
          "name": "EasyWeed\u00ae Stretch Chestnut",
          "solid_hex_color": "#7c3634",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-bright-red": {
          "id": "stretch-bright-red",
          "name": "EasyWeed\u00ae Stretch Bright Red",
          "solid_hex_color": "#e00001",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-red": {
          "id": "stretch-red",
          "name": "EasyWeed\u00ae Stretch Red",
          "solid_hex_color": "#c60000",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-burgundy": {
          "id": "stretch-burgundy",
          "name": "EasyWeed\u00ae Stretch Burgundy",
          "solid_hex_color": "#732835",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-black": {
          "id": "stretch-black",
          "name": "EasyWeed\u00ae Stretch Black",
          "solid_hex_color": "#1e0701",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-charcoal": {
          "id": "stretch-charcoal",
          "name": "EasyWeed\u00ae Stretch Charcoal",
          "solid_hex_color": "#5e666c",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-gray": {
          "id": "stretch-gray",
          "name": "EasyWeed\u00ae Stretch Gray",
          "solid_hex_color": "#9b9fa2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-silver": {
          "id": "stretch-silver",
          "name": "EasyWeed\u00ae Stretch Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12100417\/stretch-silver.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12100417\/stretch-silver-150x150.png"
          }
        },
        "stretch-white": {
          "id": "stretch-white",
          "name": "EasyWeed\u00ae Stretch White",
          "solid_hex_color": "#ffffff",
          "tile_image_urls": []
        }
      },
      "easyweed-sub-block": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "easyweed-sub-block",
        "materials": [],
        "name": "EasyWeed\u00ae Sub Block",
        "subblock-barcelona-yellow": {
          "id": "subblock-barcelona-yellow",
          "name": "EasyWeed\u00ae Sub Block Barcelona Yellow",
          "solid_hex_color": "#F7E14A",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "subblock-white": {
          "id": "subblock-white",
          "name": "EasyWeed\u00ae Sub Block White",
          "solid_hex_color": "#EFF0F1",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "glitter": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 25,
              "speed": 10
            }
          }
        },
        "id": "glitter",
        "materials": [],
        "name": "Glitter\u00ae",
        "glitter-neon-purple": {
          "id": "glitter-neon-purple",
          "name": "Glitter Neon Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141455\/glitter-neon-purple.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141455\/glitter-neon-purple-150x150.jpg"
          }
        },
        "glitter-neon-blue": {
          "id": "glitter-neon-blue",
          "name": "Glitter Neon Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141453\/glitter-neon-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141453\/glitter-neon-blue-150x150.jpg"
          }
        },
        "glitter-neon-green": {
          "id": "glitter-neon-green",
          "name": "Glitter Neon Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141450\/glitter-neon-green.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141450\/glitter-neon-green-150x150.jpg"
          }
        },
        "glitter-neon-yellow": {
          "id": "glitter-neon-yellow",
          "name": "Glitter Neon Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141448\/glitter-neon-yellow.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141448\/glitter-neon-yellow-150x150.jpg"
          }
        },
        "glitter-neon-orange": {
          "id": "glitter-neon-orange",
          "name": "Glitter Neon Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141435\/glitter-neon-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141435\/glitter-neon-orange-150x150.jpeg"
          }
        },
        "glitter-neon-grapefruit": {
          "id": "glitter-neon-grapefruit",
          "name": "Glitter Neon Grapefruit",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141433\/glitter-neon-grapefruit.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141433\/glitter-neon-grapefruit-150x150.jpeg"
          }
        },
        "glitter-neon-pink": {
          "id": "glitter-neon-pink",
          "name": "Glitter Neon Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141430\/glitter-neon-pink.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141430\/glitter-neon-pink-150x150.jpg"
          }
        },
        "glitter-rainbow-coral": {
          "id": "glitter-rainbow-coral",
          "name": "Glitter Rainbow Coral",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141428\/glitter-rainbow-coral.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141428\/glitter-rainbow-coral-150x150.jpg"
          }
        },
        "glitter-rainbow-plum": {
          "id": "glitter-rainbow-plum",
          "name": "Glitter Rainbow Plum",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141425\/glitter-rainbow-plum.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141425\/glitter-rainbow-plum-150x150.jpeg"
          }
        },
        "glitter-rose-gold": {
          "id": "glitter-rose-gold",
          "name": "Glitter Rose Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141343\/glitter-rose-gold.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141343\/glitter-rose-gold-150x150.jpg"
          }
        },
        "glitter-blush": {
          "id": "glitter-blush",
          "name": "Glitter Blush",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141334\/glitter-blush.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141334\/glitter-blush-150x150.jpg"
          }
        },
        "glitter-cherry": {
          "id": "glitter-cherry",
          "name": "Glitter Cherry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141325\/glitter-cherry.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141325\/glitter-cherry-150x150.jpg"
          }
        },
        "glitter-hot-pink": {
          "id": "glitter-hot-pink",
          "name": "Glitter Hot Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141313\/glitter-hot-pink.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141313\/glitter-hot-pink-150x150.jpg"
          }
        },
        "glitter-flamingo-pink": {
          "id": "glitter-flamingo-pink",
          "name": "Glitter Flamingo Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141308\/glitter-flamingo.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141308\/glitter-flamingo-150x150.jpg"
          }
        },
        "glitter-translucent-light-pink": {
          "id": "glitter-translucent-light-pink",
          "name": "Glitter Translucent Light Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141300\/glitter-translucent-pink.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141300\/glitter-translucent-pink-150x150.jpg"
          }
        },
        "glitter-currant": {
          "id": "glitter-currant",
          "name": "Glitter Currant",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141249\/glitter-currant.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141249\/glitter-currant-150x150.jpg"
          }
        },
        "glitter-lavender": {
          "id": "glitter-lavender",
          "name": "Glitter Lavender",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141221\/glitter-lavender.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141221\/glitter-lavender-150x150.jpg"
          }
        },
        "glitter-eggplant": {
          "id": "glitter-eggplant",
          "name": "Glitter Eggplant",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141215\/glitter-eggplant.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141215\/glitter-eggplant-150x150.jpg"
          }
        },
        "glitter-purple": {
          "id": "glitter-purple",
          "name": "Glitter Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141209\/glitter-purple.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141209\/glitter-purple-150x150.jpg"
          }
        },
        "glitter-lilac": {
          "id": "glitter-lilac",
          "name": "Glitter Lilac",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141152\/glitter-lilac.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141152\/glitter-lilac-150x150.jpg"
          }
        },
        "glitter-royal-blue": {
          "id": "glitter-royal-blue",
          "name": "Glitter Royal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141146\/glitter-royal-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141146\/glitter-royal-blue-150x150.jpg"
          }
        },
        "glitter-sapphire": {
          "id": "glitter-sapphire",
          "name": "Glitter Sapphire",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141129\/glitter-sapphire.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141129\/glitter-sapphire-150x150.jpg"
          }
        },
        "glitter-true-blue": {
          "id": "glitter-true-blue",
          "name": "Glitter True Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141651\/glitter-true-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141651\/glitter-true-blue-150x150.jpg"
          }
        },
        "glitter-old-blue": {
          "id": "glitter-old-blue",
          "name": "Glitter Old Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121927\/glitter-old-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121927\/glitter-old-blue-150x150.jpg"
          }
        },
        "glitter-blue": {
          "id": "glitter-blue",
          "name": "Glitter Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121922\/glitter-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121922\/glitter-blue-150x150.jpg"
          }
        },
        "glitter-aqua": {
          "id": "glitter-aqua",
          "name": "Glitter Aqua",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121919\/glitter-aqua.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121919\/glitter-aqua-150x150.jpg"
          }
        },
        "glitter-lagoon": {
          "id": "glitter-lagoon",
          "name": "Glitter Lagoon",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121915\/glitter-lagoon.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121915\/glitter-lagoon-150x150.jpg"
          }
        },
        "glitter-mermaid-blue": {
          "id": "glitter-mermaid-blue",
          "name": "Glitter Mermaid Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121854\/glitter-mermaid-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121854\/glitter-mermaid-blue-150x150.jpg"
          }
        },
        "glitter-mint": {
          "id": "glitter-mint",
          "name": "Glitter Mint",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121839\/glitter-mint.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121839\/glitter-mint-150x150.jpg"
          }
        },
        "glitter-jade": {
          "id": "glitter-jade",
          "name": "Glitter Jade",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121836\/glitter-jade.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121836\/glitter-jade-150x150.jpeg"
          }
        },
        "glitter-emerald": {
          "id": "glitter-emerald",
          "name": "Glitter Emerald",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121550\/glitter-emerald.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121550\/glitter-emerald-150x150.jpg"
          }
        },
        "glitter-grass": {
          "id": "glitter-grass",
          "name": "Glitter Grass",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121544\/glitter-grass.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121544\/glitter-grass-150x150.jpg"
          }
        },
        "glitter-dark-green": {
          "id": "glitter-dark-green",
          "name": "Glitter Dark Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121538\/glitter-dark-green.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121538\/glitter-dark-green-150x150.jpg"
          }
        },
        "glitter-light-green": {
          "id": "glitter-light-green",
          "name": "Glitter Light Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121532\/glitter-light-green.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121532\/glitter-light-green-150x150.jpg"
          }
        },
        "glitter-gold-confetti": {
          "id": "glitter-gold-confetti",
          "name": "Glitter Gold Confetti",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121445\/glitter-gold-confetti.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121445\/glitter-gold-confetti-150x150.jpg"
          }
        },
        "glitter-champagne": {
          "id": "glitter-champagne",
          "name": "Glitter Champagne",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121407\/glitter-champagne.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121407\/glitter-champagne-150x150.jpg"
          }
        },
        "glitter-brown": {
          "id": "glitter-brown",
          "name": "Glitter Brown",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121315\/glitter-brown.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121315\/glitter-brown-150x150.jpg"
          }
        },
        "glitter-tawny": {
          "id": "glitter-tawny",
          "name": "Glitter Tawny",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121225\/glitter-tawny.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121225\/glitter-tawny-150x150.jpg"
          }
        },
        "glitter-old-gold": {
          "id": "glitter-old-gold",
          "name": "Glitter Old Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121136\/glitter-old-gold.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121136\/glitter-old-gold-150x150.jpg"
          }
        },
        "glitter-lemon-sugar": {
          "id": "glitter-lemon-sugar",
          "name": "Glitter Lemon Sugar",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121041\/glitter-lemon-sugar.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121041\/glitter-lemon-sugar-150x150.jpg"
          }
        },
        "glitter-gold": {
          "id": "glitter-gold",
          "name": "Glitter Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121001\/glitter-gold.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121001\/glitter-gold-150x150.jpg"
          }
        },
        "glitter-translucent-orange": {
          "id": "glitter-translucent-orange",
          "name": "Glitter Translucent Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120917\/glitter-translucent-orange.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120917\/glitter-translucent-orange-150x150.jpg"
          }
        },
        "glitter-ember-orange": {
          "id": "glitter-ember-orange",
          "name": "Glitter Ember Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120829\/glitter-ember-orange.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120829\/glitter-ember-orange-150x150.jpg"
          }
        },
        "glitter-copper": {
          "id": "glitter-copper",
          "name": "Glitter Copper",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120739\/glitter-copper.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120739\/glitter-copper-150x150.jpg"
          }
        },
        "glitter-bronze": {
          "id": "glitter-bronze",
          "name": "Glitter Bronze",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120646\/glitter-bronze.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120646\/glitter-bronze-150x150.jpg"
          }
        },
        "glitter-red": {
          "id": "glitter-red",
          "name": "Glitter Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120512\/glitter-red.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120512\/glitter-red-150x150.jpg"
          }
        },
        "glitter-burgundy": {
          "id": "glitter-burgundy",
          "name": "Glitter Burgundy",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120204\/glitter-burgundy.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120204\/glitter-burgundy-150x150.jpg"
          }
        },
        "glitter-black-gold": {
          "id": "glitter-black-gold",
          "name": "Glitter Black Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120048\/glitter-black-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120048\/glitter-black-gold-150x150.jpeg"
          }
        },
        "glitter-dark-walnut": {
          "id": "glitter-dark-walnut",
          "name": "Glitter Dark Walnut",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120008\/glitter-dark-walnut.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120008\/glitter-dark-walnut-150x150.jpg"
          }
        },
        "glitter-galaxy-black": {
          "id": "glitter-galaxy-black",
          "name": "Glitter Galaxy Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115915\/glitter-galaxy-black.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115915\/glitter-galaxy-black-150x150.jpg"
          }
        },
        "glitter-black": {
          "id": "glitter-black",
          "name": "Glitter Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115802\/glitter-black.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115802\/glitter-black-150x150.jpg"
          }
        },
        "glitter-black-silver": {
          "id": "glitter-black-silver",
          "name": "Glitter Black Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115717\/glitter-black-silver.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115717\/glitter-black-silver-150x150.jpg"
          }
        },
        "glitter-light-multi": {
          "id": "glitter-light-multi",
          "name": "Glitter Light Multi",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115614\/glitter-light-multi.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115614\/glitter-light-multi-150x150.jpg"
          }
        },
        "glitter-confetti": {
          "id": "glitter-confetti",
          "name": "Glitter Confetti",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115334\/glitter-confetti.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115334\/glitter-confetti-150x150.jpg"
          }
        },
        "glitter-silver-confetti": {
          "id": "glitter-silver-confetti",
          "name": "Glitter Silver Confetti",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115246\/glitter-silver-confetti.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115246\/glitter-silver-confetti-150x150.jpg"
          }
        },
        "glitter-silver": {
          "id": "glitter-silver",
          "name": "Glitter Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115151\/glitter-silver.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115151\/glitter-silver-150x150.jpg"
          }
        },
        "glitter-rainbow-white": {
          "id": "glitter-rainbow-white",
          "name": "Glitter Rainbow White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115118\/glitter-rainbow-white.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115118\/glitter-rainbow-white-150x150.jpg"
          }
        },
        "glitter-white-2": {
          "id": "glitter-white-2",
          "name": "Glitter White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09114949\/glitter-white.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09114949\/glitter-white-150x150.jpg"
          }
        }
      },
      "heat-transfer-vinyl": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "heat-transfer-vinyl",
        "materials": [],
        "name": "Heat Transfer Vinyl",
        "diamond-dust-wild-cherry": {
          "id": "diamond-dust-wild-cherry",
          "name": "Diamond Dust\u2122 Wild Cherry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115832\/dust-wild-cherry.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115832\/dust-wild-cherry-150x150.jpeg"
          }
        },
        "diamond-dust-sour-apple": {
          "id": "diamond-dust-sour-apple",
          "name": "Diamond Dust\u2122 Sour Apple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115831\/dust-sour-apple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115831\/dust-sour-apple-150x150.jpeg"
          }
        },
        "diamond-dust-pink-salt": {
          "id": "diamond-dust-pink-salt",
          "name": "Diamond Dust\u2122 Pink Salt",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115830\/dust-pink-salt.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115830\/dust-pink-salt-150x150.jpeg"
          }
        },
        "diamond-dust-pastel-lilac": {
          "id": "diamond-dust-pastel-lilac",
          "name": "Diamond Dust\u2122 Pastel Lilac",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115829\/dust-pastel-lilac.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115829\/dust-pastel-lilac-150x150.jpeg"
          }
        },
        "diamond-dust-orange-slice": {
          "id": "diamond-dust-orange-slice",
          "name": "Diamond Dust\u2122 Orange Slice",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115828\/dust-orange-slice.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115828\/dust-orange-slice-150x150.jpeg"
          }
        },
        "diamond-dust-dream-gray": {
          "id": "diamond-dust-dream-gray",
          "name": "Diamond Dust\u2122 Dream Gray",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115828\/dust-dream-gray.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115828\/dust-dream-gray-150x150.jpeg"
          }
        },
        "diamond-dust-cinnamon-rose": {
          "id": "diamond-dust-cinnamon-rose",
          "name": "Diamond Dust\u2122 Cinnamon Rose",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115827\/dust-cinnamon-rose.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115827\/dust-cinnamon-rose-150x150.jpeg"
          }
        },
        "diamond-dust-blue-raspberry": {
          "id": "diamond-dust-blue-raspberry",
          "name": "Diamond Dust\u2122 Blue Raspberry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115525\/dust-blue-raspberry.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2023\/02\/14115525\/dust-blue-raspberry-150x150.jpeg"
          }
        },
        "easy-puff-beige": {
          "id": "easy-puff-beige",
          "name": "Easy\u2122 Puff Beige",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-deep-pink": {
          "id": "easy-puff-deep-pink",
          "name": "Easy\u2122 Puff Deep Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-dark-gray": {
          "id": "easy-puff-dark-gray",
          "name": "Easy\u2122 Puff Dark Gray",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-forest-green": {
          "id": "easy-puff-forest-green",
          "name": "Easy\u2122 Puff Forest Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-camel": {
          "id": "easy-puff-camel",
          "name": "Easy\u2122 Puff Camel",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-apple-green": {
          "id": "easy-puff-apple-green",
          "name": "Easy\u2122 Puff Apple Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-light-gray": {
          "id": "easy-puff-light-gray",
          "name": "Easy\u2122 Puff Light Gray",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-neon-blue": {
          "id": "easy-puff-neon-blue",
          "name": "Easy\u2122 Puff Neon Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-neon-orange": {
          "id": "easy-puff-neon-orange",
          "name": "Easy\u2122 Puff Neon Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-neon-yellow": {
          "id": "easy-puff-neon-yellow",
          "name": "Easy\u2122 Puff Neon Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-purple": {
          "id": "easy-puff-purple",
          "name": "Easy\u2122 Puff Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-wine": {
          "id": "easy-puff-wine",
          "name": "Easy\u2122 Puff Wine",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-sky": {
          "id": "easy-puff-sky",
          "name": "Easy\u2122 Puff Sky",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-pink": {
          "id": "easy-puff-pink",
          "name": "Easy\u2122 Puff Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-orange": {
          "id": "easy-puff-orange",
          "name": "Easy\u2122 Puff Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-green": {
          "id": "easy-puff-green",
          "name": "Easy\u2122 Puff Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-yellow": {
          "id": "easy-puff-yellow",
          "name": "Easy\u2122 Puff Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-red": {
          "id": "easy-puff-red",
          "name": "Easy\u2122 Puff Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-navy": {
          "id": "easy-puff-navy",
          "name": "Easy\u2122 Puff Navy",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-black": {
          "id": "easy-puff-black",
          "name": "Easy\u2122 Puff Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easy-puff-white": {
          "id": "easy-puff-white",
          "name": "Easy\u2122 Puff White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "aurora-pink": {
          "id": "aurora-pink",
          "name": "Aurora\u2122 Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105724\/aurora-light-pink.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105724\/aurora-light-pink-150x150.png"
          }
        },
        "aurora-light-blue": {
          "id": "aurora-light-blue",
          "name": "Aurora\u2122 Light Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105356\/aurora-light-blue.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105356\/aurora-light-blue-150x150.png"
          }
        },
        "aurora-borealis-teal": {
          "id": "aurora-borealis-teal",
          "name": "Aurora\u2122 Borealis Teal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105046\/aurora-borealis-teal.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105046\/aurora-borealis-teal-150x150.png"
          }
        },
        "aurora-light-green": {
          "id": "aurora-light-green",
          "name": "Aurora\u2122 Light Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105540\/aurora-light-green.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105540\/aurora-light-green-150x150.png"
          }
        },
        "aurora-goldish": {
          "id": "aurora-goldish",
          "name": "Aurora\u2122 Goldish",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105240\/aurora-golden.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105240\/aurora-golden-150x150.png"
          }
        },
        "aurora-yellow": {
          "id": "aurora-yellow",
          "name": "Aurora\u2122 Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110527\/aurora-yellow.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110527\/aurora-yellow-150x150.png"
          }
        },
        "aurora-red": {
          "id": "aurora-red",
          "name": "Aurora\u2122 Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110042\/aurora-red.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110042\/aurora-red-150x150.png"
          }
        },
        "aurora-parakeet": {
          "id": "aurora-parakeet",
          "name": "Aurora\u2122 Parakeet",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105857\/aurora-parakeet.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06105857\/aurora-parakeet-150x150.png"
          }
        },
        "aurora-silver": {
          "id": "aurora-silver",
          "name": "Aurora\u2122 Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110223\/aurora-silver.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110223\/aurora-silver-150x150.png"
          }
        },
        "aurora-white": {
          "id": "aurora-white",
          "name": "Aurora\u2122 White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110354\/aurora-white.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/06110354\/aurora-white-150x150.png"
          }
        },
        "brick-fluorescent-blue": {
          "id": "brick-fluorescent-blue",
          "name": "Brick\u00ae 600 Fluorescent Blue",
          "solid_hex_color": "#0077CF",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-fluorescent-pink": {
          "id": "brick-fluorescent-pink",
          "name": "Brick\u00ae 600 Fluorescent Pink",
          "solid_hex_color": "#FF48B0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-fluorescent-green": {
          "id": "brick-fluorescent-green",
          "name": "Brick\u00ae 600 Fluorescent Green",
          "solid_hex_color": "#3BD23D",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-fluorescent-orange": {
          "id": "brick-fluorescent-orange",
          "name": "Brick\u00ae 600 Fluorescent Orange",
          "solid_hex_color": "#FF8F6C",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-fluorescent-yellow": {
          "id": "brick-fluorescent-yellow",
          "name": "Brick\u00ae 600 Fluorescent Yellow",
          "solid_hex_color": "#E3E829",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-navy-blue": {
          "id": "brick-navy-blue",
          "name": "Brick\u00ae 600 Navy Blue",
          "solid_hex_color": "#414C60",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-royal-blue": {
          "id": "brick-royal-blue",
          "name": "Brick\u00ae 600 Royal Blue",
          "solid_hex_color": "#34558B",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-green": {
          "id": "brick-green",
          "name": "Brick\u00ae 600 Green",
          "solid_hex_color": "#376C59",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-yellow": {
          "id": "brick-yellow",
          "name": "Brick\u00ae 600 Yellow",
          "solid_hex_color": "#FEB236",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-red": {
          "id": "brick-red",
          "name": "Brick\u00ae 600 Red",
          "solid_hex_color": "#8A2A2B",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-black": {
          "id": "brick-black",
          "name": "Brick\u00ae 600 Black",
          "solid_hex_color": "#3B3F42",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "brick-white": {
          "id": "brick-white",
          "name": "Brick\u00ae 600 White",
          "solid_hex_color": "#EFF0F1",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "subblock-barcelona-yellow": {
          "id": "subblock-barcelona-yellow",
          "name": "EasyWeed\u00ae Sub Block Barcelona Yellow",
          "solid_hex_color": "#F7E14A",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-rose-gold": {
          "id": "stretch-rose-gold",
          "name": "EasyWeed\u00ae Stretch Rose Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12095542\/stretch-rose-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12095542\/stretch-rose-gold-150x150.png"
          }
        },
        "stretch-ballerina-pink": {
          "id": "stretch-ballerina-pink",
          "name": "EasyWeed\u00ae Stretch Ballerina Pink",
          "solid_hex_color": "#fdded0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-coral": {
          "id": "stretch-coral",
          "name": "EasyWeed\u00ae Stretch Coral",
          "solid_hex_color": "#f68683",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-bubblegum": {
          "id": "stretch-bubblegum",
          "name": "EasyWeed\u00ae Stretch Bubblegum",
          "solid_hex_color": "#fb7ea8",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-passion-pink": {
          "id": "stretch-passion-pink",
          "name": "EasyWeed\u00ae Stretch Passion Pink",
          "solid_hex_color": "#d91e76",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-bright-orchid": {
          "id": "stretch-bright-orchid",
          "name": "EasyWeed\u00ae Stretch Bright Orchid",
          "solid_hex_color": "#cd73ab",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-purple-berry": {
          "id": "stretch-purple-berry",
          "name": "EasyWeed\u00ae Stretch Purple Berry",
          "solid_hex_color": "#8a1ca3",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-lilac": {
          "id": "stretch-lilac",
          "name": "EasyWeed\u00ae Stretch Lilac",
          "solid_hex_color": "#c9b3da",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-wisteria": {
          "id": "stretch-wisteria",
          "name": "EasyWeed\u00ae Stretch Wisteria",
          "solid_hex_color": "#8674ad",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-royal-purple": {
          "id": "stretch-royal-purple",
          "name": "EasyWeed\u00ae Stretch Royal Purple",
          "solid_hex_color": "#4f4696",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-cobalt-blue": {
          "id": "stretch-cobalt-blue",
          "name": "EasyWeed\u00ae Stretch Cobalt Blue",
          "solid_hex_color": "#33429f",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-navy-blue": {
          "id": "stretch-navy-blue",
          "name": "EasyWeed\u00ae Stretch Navy Blue",
          "solid_hex_color": "#08132b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-royal-blue": {
          "id": "stretch-royal-blue",
          "name": "EasyWeed\u00ae Stretch Royal Blue",
          "solid_hex_color": "#01237d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-celestial-blue": {
          "id": "stretch-celestial-blue",
          "name": "EasyWeed\u00ae Stretch Celestial Blue",
          "solid_hex_color": "#0197df",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-pale-blue": {
          "id": "stretch-pale-blue",
          "name": "EasyWeed\u00ae Stretch Pale Blue",
          "solid_hex_color": "#6bcaf2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-frosty-mint": {
          "id": "stretch-frosty-mint",
          "name": "EasyWeed\u00ae Stretch Frosty Mint",
          "solid_hex_color": "#a6e1e7",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-totally-teal": {
          "id": "stretch-totally-teal",
          "name": "EasyWeed\u00ae Stretch Totally Teal",
          "solid_hex_color": "#0198a5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-sea-glass": {
          "id": "stretch-sea-glass",
          "name": "EasyWeed\u00ae Stretch Sea Glass",
          "solid_hex_color": "#7dd6d0",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-sweet-mint": {
          "id": "stretch-sweet-mint",
          "name": "EasyWeed\u00ae Stretch Sweet Mint",
          "solid_hex_color": "#affbd5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-green": {
          "id": "stretch-green",
          "name": "EasyWeed\u00ae Stretch Green",
          "solid_hex_color": "#016e49",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-pine-green": {
          "id": "stretch-pine-green",
          "name": "EasyWeed\u00ae Stretch Pine Green",
          "solid_hex_color": "#28544a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-dark-gold": {
          "id": "stretch-dark-gold",
          "name": "EasyWeed\u00ae Stretch Dark Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094940\/stretch-dark-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094940\/stretch-dark-gold-150x150.png"
          }
        },
        "stretch-gold": {
          "id": "stretch-gold",
          "name": "EasyWeed\u00ae Stretch Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094801\/stretch-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094801\/stretch-gold-150x150.png"
          }
        },
        "stretch-lemon": {
          "id": "stretch-lemon",
          "name": "EasyWeed\u00ae Stretch Lemon",
          "solid_hex_color": "#fee801",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-yellow": {
          "id": "stretch-yellow",
          "name": "EasyWeed\u00ae Stretch Yellow",
          "solid_hex_color": "#ffb401",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-sun": {
          "id": "stretch-sun",
          "name": "EasyWeed\u00ae Stretch Sun",
          "solid_hex_color": "#ffa600",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-orange": {
          "id": "stretch-orange",
          "name": "EasyWeed\u00ae Stretch Orange",
          "solid_hex_color": "#f94801",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-calypso-coral": {
          "id": "stretch-calypso-coral",
          "name": "EasyWeed\u00ae Stretch Calypso Coral",
          "solid_hex_color": "#fe6b61",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-coffee": {
          "id": "stretch-coffee",
          "name": "EasyWeed\u00ae Stretch Coffee",
          "solid_hex_color": "#786153",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-chestnut": {
          "id": "stretch-chestnut",
          "name": "EasyWeed\u00ae Stretch Chestnut",
          "solid_hex_color": "#7c3634",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-bright-red": {
          "id": "stretch-bright-red",
          "name": "EasyWeed\u00ae Stretch Bright Red",
          "solid_hex_color": "#e00001",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-red": {
          "id": "stretch-red",
          "name": "EasyWeed\u00ae Stretch Red",
          "solid_hex_color": "#c60000",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-burgundy": {
          "id": "stretch-burgundy",
          "name": "EasyWeed\u00ae Stretch Burgundy",
          "solid_hex_color": "#732835",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-black": {
          "id": "stretch-black",
          "name": "EasyWeed\u00ae Stretch Black",
          "solid_hex_color": "#1e0701",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-charcoal": {
          "id": "stretch-charcoal",
          "name": "EasyWeed\u00ae Stretch Charcoal",
          "solid_hex_color": "#5e666c",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-gray": {
          "id": "stretch-gray",
          "name": "EasyWeed\u00ae Stretch Gray",
          "solid_hex_color": "#9b9fa2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-silver": {
          "id": "stretch-silver",
          "name": "EasyWeed\u00ae Stretch Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12100417\/stretch-silver.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12100417\/stretch-silver-150x150.png"
          }
        },
        "ew-fluorescent-blue": {
          "id": "ew-fluorescent-blue",
          "name": "EasyWeed\u00ae Fluorescent Blue",
          "solid_hex_color": "#3260ad",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-green": {
          "id": "ew-fluorescent-green",
          "name": "EasyWeed\u00ae Fluorescent Green",
          "solid_hex_color": "#65bd4d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-yellow": {
          "id": "ew-fluorescent-yellow",
          "name": "EasyWeed\u00ae Fluorescent Yellow",
          "solid_hex_color": "#eae721",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-orange": {
          "id": "ew-fluorescent-orange",
          "name": "EasyWeed\u00ae Fluorescent Orange",
          "solid_hex_color": "#f27a21",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-coral": {
          "id": "ew-fluorescent-coral",
          "name": "EasyWeed\u00ae Fluorescent Coral",
          "solid_hex_color": "#ec2228",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easyweed-fluorescent-raspberry": {
          "id": "easyweed-fluorescent-raspberry",
          "name": "EasyWeed\u00ae Fluorescent Raspberry",
          "solid_hex_color": "#ed1876",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-fluorescent-pink": {
          "id": "ew-fluorescent-pink",
          "name": "EasyWeed\u00ae Fluorescent Pink",
          "solid_hex_color": "#eb2c92",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-light-pink": {
          "id": "ew-light-pink",
          "name": "EasyWeed\u00ae Light Pink",
          "solid_hex_color": "#ecc0c5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-pale-peach": {
          "id": "ew-pale-peach",
          "name": "EasyWeed\u00ae Pale Peach",
          "solid_hex_color": "#edbeab",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-melon": {
          "id": "ew-melon",
          "name": "EasyWeed\u00ae Melon",
          "solid_hex_color": "#f8a89d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-bubblegum": {
          "id": "ew-bubblegum",
          "name": "EasyWeed\u00ae Bubblegum",
          "solid_hex_color": "#e983b2",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-pink": {
          "id": "ew-pink",
          "name": "EasyWeed\u00ae Pink",
          "solid_hex_color": "#d91d76",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-passion-pink": {
          "id": "ew-passion-pink",
          "name": "EasyWeed\u00ae Passion Pink",
          "solid_hex_color": "#d31a6b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-lilac": {
          "id": "ew-lilac",
          "name": "EasyWeed\u00ae Lilac",
          "solid_hex_color": "#b995c5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-wicked-purple": {
          "id": "ew-wicked-purple",
          "name": "EasyWeed\u00ae Wicked Purple",
          "solid_hex_color": "#66538a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-purple": {
          "id": "ew-purple",
          "name": "EasyWeed\u00ae Purple",
          "solid_hex_color": "#1b1145",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-navy-blue": {
          "id": "ew-navy-blue",
          "name": "EasyWeed\u00ae Navy Blue",
          "solid_hex_color": "#0d162d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-royal-blue": {
          "id": "ew-royal-blue",
          "name": "EasyWeed\u00ae Royal Blue",
          "solid_hex_color": "#293476",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-periwinkle": {
          "id": "ew-periwinkle",
          "name": "EasyWeed\u00ae Periwinkle",
          "solid_hex_color": "#98c4e1",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-pale-blue": {
          "id": "ew-pale-blue",
          "name": "EasyWeed\u00ae Pale Blue",
          "solid_hex_color": "#9fb3d9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-sky-blue": {
          "id": "ew-sky-blue",
          "name": "EasyWeed\u00ae Sky Blue",
          "solid_hex_color": "#1472b9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-powder-blue": {
          "id": "ew-powder-blue",
          "name": "EasyWeed\u00ae Powder Blue",
          "solid_hex_color": "#bfcdd7",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-turquoise": {
          "id": "ew-turquoise",
          "name": "EasyWeed\u00ae Turquoise",
          "solid_hex_color": "#01506d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-retro-mint": {
          "id": "ew-retro-mint",
          "name": "EasyWeed\u00ae Retro Mint",
          "solid_hex_color": "#66c6b9",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-dark-green": {
          "id": "ew-dark-green",
          "name": "EasyWeed\u00ae Dark Green",
          "solid_hex_color": "#16281b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-green-olive": {
          "id": "ew-green-olive",
          "name": "EasyWeed\u00ae Green Olive",
          "solid_hex_color": "#67704a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-sage": {
          "id": "ew-sage",
          "name": "EasyWeed\u00ae Sage",
          "solid_hex_color": "#a8cbb5",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-cadette-green": {
          "id": "ew-cadette-green",
          "name": "EasyWeed\u00ae Cadette Green",
          "solid_hex_color": "#198965",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-green": {
          "id": "ew-green",
          "name": "EasyWeed\u00ae Green",
          "solid_hex_color": "#00704a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-green-apple": {
          "id": "ew-green-apple",
          "name": "EasyWeed\u00ae Green Apple",
          "solid_hex_color": "#6eb94d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-lime": {
          "id": "ew-lime",
          "name": "EasyWeed\u00ae Lime",
          "solid_hex_color": "#c5d92e",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-mocha": {
          "id": "ew-mocha",
          "name": "EasyWeed\u00ae Mocha",
          "solid_hex_color": "#7b5646",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-chocolate": {
          "id": "ew-chocolate",
          "name": "EasyWeed\u00ae Chocolate",
          "solid_hex_color": "#875422",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-hazelnut": {
          "id": "ew-hazelnut",
          "name": "EasyWeed\u00ae Hazelnut",
          "solid_hex_color": "#9d6c59",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-latte": {
          "id": "ew-latte",
          "name": "EasyWeed\u00ae Latte",
          "solid_hex_color": "#b38674",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-tan": {
          "id": "ew-tan",
          "name": "EasyWeed\u00ae Tan",
          "solid_hex_color": "#ce9862",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-cashew": {
          "id": "ew-cashew",
          "name": "EasyWeed\u00ae Cashew",
          "solid_hex_color": "#d1ab8c",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-light-apricot": {
          "id": "ew-light-apricot",
          "name": "EasyWeed\u00ae Light Apricot",
          "solid_hex_color": "#f8cba6",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-cream": {
          "id": "ew-cream",
          "name": "EasyWeed\u00ae Cream",
          "solid_hex_color": "#eacc9d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-vegas-gold": {
          "id": "ew-vegas-gold",
          "name": "EasyWeed\u00ae Vegas Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094409\/ew-vegas-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094409\/ew-vegas-gold-150x150.png"
          }
        },
        "ew-gold": {
          "id": "ew-gold",
          "name": "EasyWeed\u00ae Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094059\/ew-gold.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/12094059\/ew-gold-150x150.png"
          }
        },
        "ew-lemon": {
          "id": "ew-lemon",
          "name": "EasyWeed\u00ae Lemon",
          "solid_hex_color": "#f6dd05",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-yellow": {
          "id": "ew-yellow",
          "name": "EasyWeed\u00ae Yellow",
          "solid_hex_color": "#ffb401",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-sun": {
          "id": "ew-sun",
          "name": "EasyWeed\u00ae Sun",
          "solid_hex_color": "#faa51b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-mustard": {
          "id": "ew-mustard",
          "name": "EasyWeed\u00ae Mustard",
          "solid_hex_color": "#e2a035",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-orange-soda": {
          "id": "ew-orange-soda",
          "name": "EasyWeed\u00ae Orange Soda",
          "solid_hex_color": "#f37137",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-orange": {
          "id": "ew-orange",
          "name": "EasyWeed\u00ae Orange",
          "solid_hex_color": "#f04c25",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-texas-orange": {
          "id": "ew-texas-orange",
          "name": "EasyWeed\u00ae Texas Orange",
          "solid_hex_color": "#b73326",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-cardinal": {
          "id": "ew-cardinal",
          "name": "EasyWeed\u00ae Cardinal",
          "solid_hex_color": "#87181a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-hibiscus": {
          "id": "ew-hibiscus",
          "name": "EasyWeed\u00ae Hibiscus",
          "solid_hex_color": "#ee343d",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-red": {
          "id": "ew-red",
          "name": "EasyWeed\u00ae Red",
          "solid_hex_color": "#c62127",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-burgundy": {
          "id": "ew-burgundy",
          "name": "EasyWeed\u00ae Burgundy",
          "solid_hex_color": "#8a1824",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-maroon": {
          "id": "ew-maroon",
          "name": "EasyWeed\u00ae Maroon",
          "solid_hex_color": "#54313a",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-dark-maroon": {
          "id": "ew-dark-maroon",
          "name": "EasyWeed\u00ae Dark Maroon",
          "solid_hex_color": "#381a26",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-brown": {
          "id": "ew-brown",
          "name": "EasyWeed\u00ae Brown",
          "solid_hex_color": "#3d1916",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-black": {
          "id": "ew-black",
          "name": "EasyWeed\u00ae Black",
          "solid_hex_color": "#0b0b0b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-charcoal": {
          "id": "ew-charcoal",
          "name": "EasyWeed\u00ae Charcoal",
          "solid_hex_color": "#43424b",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-gray": {
          "id": "ew-gray",
          "name": "EasyWeed\u00ae Gray",
          "solid_hex_color": "#959191",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "easyreflective-2": {
          "id": "easyreflective-2",
          "name": "EasyReflective\u00ae",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09145948\/web-tile.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09145948\/web-tile-150x150.jpeg"
          }
        },
        "electric-gold-lens": {
          "id": "electric-gold-lens",
          "name": "EasyWeed\u00ae\u00a0Electric Gold Lens",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143628\/electric-gold-lens.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143628\/electric-gold-lens-150x150.jpeg"
          }
        },
        "electric-silver-lens": {
          "id": "electric-silver-lens",
          "name": "EasyWeed\u00ae\u00a0Electric Silver Lens",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143642\/electric-silver-lens.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143642\/electric-silver-lens-150x150.jpeg"
          }
        },
        "electric-rose-gold": {
          "id": "electric-rose-gold",
          "name": "EasyWeed\u00ae\u00a0Electric Rose Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143641\/electric-rose-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143641\/electric-rose-gold-150x150.jpeg"
          }
        },
        "electric-pink": {
          "id": "electric-pink",
          "name": "EasyWeed\u00ae\u00a0Electric Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143637\/electric-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143637\/electric-pink-150x150.jpeg"
          }
        },
        "electric-cherry": {
          "id": "electric-cherry",
          "name": "EasyWeed\u00ae\u00a0Electric Cherry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143622\/electric-cherry.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143622\/electric-cherry-150x150.jpeg"
          }
        },
        "electric-purple": {
          "id": "electric-purple",
          "name": "EasyWeed\u00ae\u00a0Electric Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143638\/electric-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143638\/electric-purple-150x150.jpeg"
          }
        },
        "electric-grape": {
          "id": "electric-grape",
          "name": "EasyWeed\u00ae\u00a0Electric Grape",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143629\/electric-grape.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143629\/electric-grape-150x150.jpeg"
          }
        },
        "electric-frosted-blueberry": {
          "id": "electric-frosted-blueberry",
          "name": "EasyWeed\u00ae\u00a0Electric Frosted Blueberry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143627\/electric-frosted-blueberry.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143627\/electric-frosted-blueberry-150x150.jpeg"
          }
        },
        "electric-columbia-blue": {
          "id": "electric-columbia-blue",
          "name": "EasyWeed\u00ae\u00a0Electric Columbia Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143623\/electric-columbian-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143623\/electric-columbian-blue-150x150.jpeg"
          }
        },
        "electric-blue": {
          "id": "electric-blue",
          "name": "EasyWeed\u00ae\u00a0Electric Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143621\/electric-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143621\/electric-blue-150x150.jpeg"
          }
        },
        "electric-spearmint": {
          "id": "electric-spearmint",
          "name": "EasyWeed\u00ae\u00a0Electric Spearmint",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143642\/electric-spearmint.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143642\/electric-spearmint-150x150.jpeg"
          }
        },
        "electric-peacock-teal": {
          "id": "electric-peacock-teal",
          "name": "EasyWeed\u00ae\u00a0Electric Peacock Teal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143635\/electric-peacock-teal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143635\/electric-peacock-teal-150x150.jpeg"
          }
        },
        "electric-teal": {
          "id": "electric-teal",
          "name": "EasyWeed\u00ae\u00a0Electric Teal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143644\/electric-teal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143644\/electric-teal-150x150.jpeg"
          }
        },
        "easyweed-electric-olive": {
          "id": "easyweed-electric-olive",
          "name": "EasyWeed\u00ae\u00a0Electric Olive",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143632\/electric-olive.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143632\/electric-olive-150x150.jpeg"
          }
        },
        "electric-green": {
          "id": "electric-green",
          "name": "EasyWeed\u00ae\u00a0Electric Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143630\/electric-green.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143630\/electric-green-150x150.jpg"
          }
        },
        "easyweed-electric-lime": {
          "id": "easyweed-electric-lime",
          "name": "EasyWeed\u00ae\u00a0Electric Lime",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143631\/electric-lime.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143631\/electric-lime-150x150.jpeg"
          }
        },
        "electric-yellow": {
          "id": "electric-yellow",
          "name": "EasyWeed\u00ae\u00a0Electric Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143647\/electric-yellow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143647\/electric-yellow-150x150.jpeg"
          }
        },
        "easyweed-electric-orange": {
          "id": "easyweed-electric-orange",
          "name": "EasyWeed\u00ae\u00a0Electric Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143634\/electric-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143634\/electric-orange-150x150.jpeg"
          }
        },
        "electric-red": {
          "id": "electric-red",
          "name": "EasyWeed\u00ae\u00a0Electric Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143639\/electric-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143639\/electric-red-150x150.jpeg"
          }
        },
        "electric-cranberry": {
          "id": "electric-cranberry",
          "name": "EasyWeed\u00ae\u00a0Electric Cranberry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143626\/electric-cranberry.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143626\/electric-cranberry-150x150.jpg"
          }
        },
        "electric-copper": {
          "id": "electric-copper",
          "name": "EasyWeed\u00ae\u00a0Electric Copper",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143625\/electric-copper.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143625\/electric-copper-150x150.jpeg"
          }
        },
        "electric-tungsten": {
          "id": "electric-tungsten",
          "name": "EasyWeed\u00ae\u00a0Electric Tungsten",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143645\/electric-tungsten.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143645\/electric-tungsten-150x150.jpeg"
          }
        },
        "electric-white-opal": {
          "id": "electric-white-opal",
          "name": "EasyWeed\u00ae\u00a0Electric White Opal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143646\/electric-white-opal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143646\/electric-white-opal-150x150.jpeg"
          }
        },
        "glitter-neon-purple": {
          "id": "glitter-neon-purple",
          "name": "Glitter Neon Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141455\/glitter-neon-purple.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141455\/glitter-neon-purple-150x150.jpg"
          }
        },
        "glitter-neon-blue": {
          "id": "glitter-neon-blue",
          "name": "Glitter Neon Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141453\/glitter-neon-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141453\/glitter-neon-blue-150x150.jpg"
          }
        },
        "glitter-neon-green": {
          "id": "glitter-neon-green",
          "name": "Glitter Neon Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141450\/glitter-neon-green.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141450\/glitter-neon-green-150x150.jpg"
          }
        },
        "glitter-neon-yellow": {
          "id": "glitter-neon-yellow",
          "name": "Glitter Neon Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141448\/glitter-neon-yellow.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141448\/glitter-neon-yellow-150x150.jpg"
          }
        },
        "glitter-neon-orange": {
          "id": "glitter-neon-orange",
          "name": "Glitter Neon Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141435\/glitter-neon-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141435\/glitter-neon-orange-150x150.jpeg"
          }
        },
        "glitter-neon-grapefruit": {
          "id": "glitter-neon-grapefruit",
          "name": "Glitter Neon Grapefruit",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141433\/glitter-neon-grapefruit.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141433\/glitter-neon-grapefruit-150x150.jpeg"
          }
        },
        "glitter-neon-pink": {
          "id": "glitter-neon-pink",
          "name": "Glitter Neon Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141430\/glitter-neon-pink.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141430\/glitter-neon-pink-150x150.jpg"
          }
        },
        "glitter-rainbow-coral": {
          "id": "glitter-rainbow-coral",
          "name": "Glitter Rainbow Coral",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141428\/glitter-rainbow-coral.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141428\/glitter-rainbow-coral-150x150.jpg"
          }
        },
        "glitter-rainbow-plum": {
          "id": "glitter-rainbow-plum",
          "name": "Glitter Rainbow Plum",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141425\/glitter-rainbow-plum.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141425\/glitter-rainbow-plum-150x150.jpeg"
          }
        },
        "glitter-rose-gold": {
          "id": "glitter-rose-gold",
          "name": "Glitter Rose Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141343\/glitter-rose-gold.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141343\/glitter-rose-gold-150x150.jpg"
          }
        },
        "glitter-blush": {
          "id": "glitter-blush",
          "name": "Glitter Blush",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141334\/glitter-blush.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141334\/glitter-blush-150x150.jpg"
          }
        },
        "glitter-cherry": {
          "id": "glitter-cherry",
          "name": "Glitter Cherry",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141325\/glitter-cherry.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141325\/glitter-cherry-150x150.jpg"
          }
        },
        "glitter-hot-pink": {
          "id": "glitter-hot-pink",
          "name": "Glitter Hot Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141313\/glitter-hot-pink.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141313\/glitter-hot-pink-150x150.jpg"
          }
        },
        "glitter-flamingo-pink": {
          "id": "glitter-flamingo-pink",
          "name": "Glitter Flamingo Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141308\/glitter-flamingo.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141308\/glitter-flamingo-150x150.jpg"
          }
        },
        "glitter-translucent-light-pink": {
          "id": "glitter-translucent-light-pink",
          "name": "Glitter Translucent Light Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141300\/glitter-translucent-pink.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141300\/glitter-translucent-pink-150x150.jpg"
          }
        },
        "glitter-currant": {
          "id": "glitter-currant",
          "name": "Glitter Currant",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141249\/glitter-currant.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141249\/glitter-currant-150x150.jpg"
          }
        },
        "glitter-lavender": {
          "id": "glitter-lavender",
          "name": "Glitter Lavender",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141221\/glitter-lavender.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141221\/glitter-lavender-150x150.jpg"
          }
        },
        "glitter-eggplant": {
          "id": "glitter-eggplant",
          "name": "Glitter Eggplant",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141215\/glitter-eggplant.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141215\/glitter-eggplant-150x150.jpg"
          }
        },
        "glitter-purple": {
          "id": "glitter-purple",
          "name": "Glitter Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141209\/glitter-purple.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141209\/glitter-purple-150x150.jpg"
          }
        },
        "glitter-lilac": {
          "id": "glitter-lilac",
          "name": "Glitter Lilac",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141152\/glitter-lilac.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141152\/glitter-lilac-150x150.jpg"
          }
        },
        "glitter-royal-blue": {
          "id": "glitter-royal-blue",
          "name": "Glitter Royal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141146\/glitter-royal-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141146\/glitter-royal-blue-150x150.jpg"
          }
        },
        "glitter-sapphire": {
          "id": "glitter-sapphire",
          "name": "Glitter Sapphire",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141129\/glitter-sapphire.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141129\/glitter-sapphire-150x150.jpg"
          }
        },
        "glitter-true-blue": {
          "id": "glitter-true-blue",
          "name": "Glitter True Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141651\/glitter-true-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09141651\/glitter-true-blue-150x150.jpg"
          }
        },
        "glitter-old-blue": {
          "id": "glitter-old-blue",
          "name": "Glitter Old Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121927\/glitter-old-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121927\/glitter-old-blue-150x150.jpg"
          }
        },
        "glitter-blue": {
          "id": "glitter-blue",
          "name": "Glitter Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121922\/glitter-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121922\/glitter-blue-150x150.jpg"
          }
        },
        "glitter-aqua": {
          "id": "glitter-aqua",
          "name": "Glitter Aqua",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121919\/glitter-aqua.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121919\/glitter-aqua-150x150.jpg"
          }
        },
        "glitter-lagoon": {
          "id": "glitter-lagoon",
          "name": "Glitter Lagoon",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121915\/glitter-lagoon.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121915\/glitter-lagoon-150x150.jpg"
          }
        },
        "glitter-mermaid-blue": {
          "id": "glitter-mermaid-blue",
          "name": "Glitter Mermaid Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121854\/glitter-mermaid-blue.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121854\/glitter-mermaid-blue-150x150.jpg"
          }
        },
        "glitter-mint": {
          "id": "glitter-mint",
          "name": "Glitter Mint",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121839\/glitter-mint.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121839\/glitter-mint-150x150.jpg"
          }
        },
        "glitter-jade": {
          "id": "glitter-jade",
          "name": "Glitter Jade",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121836\/glitter-jade.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121836\/glitter-jade-150x150.jpeg"
          }
        },
        "glitter-emerald": {
          "id": "glitter-emerald",
          "name": "Glitter Emerald",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121550\/glitter-emerald.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121550\/glitter-emerald-150x150.jpg"
          }
        },
        "glitter-grass": {
          "id": "glitter-grass",
          "name": "Glitter Grass",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121544\/glitter-grass.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121544\/glitter-grass-150x150.jpg"
          }
        },
        "glitter-dark-green": {
          "id": "glitter-dark-green",
          "name": "Glitter Dark Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121538\/glitter-dark-green.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121538\/glitter-dark-green-150x150.jpg"
          }
        },
        "glitter-light-green": {
          "id": "glitter-light-green",
          "name": "Glitter Light Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121532\/glitter-light-green.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121532\/glitter-light-green-150x150.jpg"
          }
        },
        "glitter-gold-confetti": {
          "id": "glitter-gold-confetti",
          "name": "Glitter Gold Confetti",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121445\/glitter-gold-confetti.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121445\/glitter-gold-confetti-150x150.jpg"
          }
        },
        "glitter-champagne": {
          "id": "glitter-champagne",
          "name": "Glitter Champagne",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121407\/glitter-champagne.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121407\/glitter-champagne-150x150.jpg"
          }
        },
        "glitter-brown": {
          "id": "glitter-brown",
          "name": "Glitter Brown",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121315\/glitter-brown.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121315\/glitter-brown-150x150.jpg"
          }
        },
        "glitter-tawny": {
          "id": "glitter-tawny",
          "name": "Glitter Tawny",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121225\/glitter-tawny.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121225\/glitter-tawny-150x150.jpg"
          }
        },
        "glitter-old-gold": {
          "id": "glitter-old-gold",
          "name": "Glitter Old Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121136\/glitter-old-gold.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121136\/glitter-old-gold-150x150.jpg"
          }
        },
        "glitter-lemon-sugar": {
          "id": "glitter-lemon-sugar",
          "name": "Glitter Lemon Sugar",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121041\/glitter-lemon-sugar.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121041\/glitter-lemon-sugar-150x150.jpg"
          }
        },
        "glitter-gold": {
          "id": "glitter-gold",
          "name": "Glitter Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121001\/glitter-gold.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09121001\/glitter-gold-150x150.jpg"
          }
        },
        "glitter-translucent-orange": {
          "id": "glitter-translucent-orange",
          "name": "Glitter Translucent Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120917\/glitter-translucent-orange.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120917\/glitter-translucent-orange-150x150.jpg"
          }
        },
        "glitter-ember-orange": {
          "id": "glitter-ember-orange",
          "name": "Glitter Ember Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120829\/glitter-ember-orange.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120829\/glitter-ember-orange-150x150.jpg"
          }
        },
        "glitter-copper": {
          "id": "glitter-copper",
          "name": "Glitter Copper",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120739\/glitter-copper.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120739\/glitter-copper-150x150.jpg"
          }
        },
        "ew-bright-red": {
          "id": "ew-bright-red",
          "name": "EasyWeed\u00ae Bright Red",
          "solid_hex_color": "#e02028",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "glitter-bronze": {
          "id": "glitter-bronze",
          "name": "Glitter Bronze",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120646\/glitter-bronze.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120646\/glitter-bronze-150x150.jpg"
          }
        },
        "glitter-red": {
          "id": "glitter-red",
          "name": "Glitter Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120512\/glitter-red.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120512\/glitter-red-150x150.jpg"
          }
        },
        "glitter-burgundy": {
          "id": "glitter-burgundy",
          "name": "Glitter Burgundy",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120204\/glitter-burgundy.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120204\/glitter-burgundy-150x150.jpg"
          }
        },
        "glitter-black-gold": {
          "id": "glitter-black-gold",
          "name": "Glitter Black Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120048\/glitter-black-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120048\/glitter-black-gold-150x150.jpeg"
          }
        },
        "glitter-dark-walnut": {
          "id": "glitter-dark-walnut",
          "name": "Glitter Dark Walnut",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120008\/glitter-dark-walnut.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09120008\/glitter-dark-walnut-150x150.jpg"
          }
        },
        "glitter-galaxy-black": {
          "id": "glitter-galaxy-black",
          "name": "Glitter Galaxy Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115915\/glitter-galaxy-black.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115915\/glitter-galaxy-black-150x150.jpg"
          }
        },
        "glitter-black": {
          "id": "glitter-black",
          "name": "Glitter Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115802\/glitter-black.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115802\/glitter-black-150x150.jpg"
          }
        },
        "glitter-black-silver": {
          "id": "glitter-black-silver",
          "name": "Glitter Black Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115717\/glitter-black-silver.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115717\/glitter-black-silver-150x150.jpg"
          }
        },
        "glitter-light-multi": {
          "id": "glitter-light-multi",
          "name": "Glitter Light Multi",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115614\/glitter-light-multi.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115614\/glitter-light-multi-150x150.jpg"
          }
        },
        "glitter-confetti": {
          "id": "glitter-confetti",
          "name": "Glitter Confetti",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115334\/glitter-confetti.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115334\/glitter-confetti-150x150.jpg"
          }
        },
        "glitter-silver-confetti": {
          "id": "glitter-silver-confetti",
          "name": "Glitter Silver Confetti",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115246\/glitter-silver-confetti.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115246\/glitter-silver-confetti-150x150.jpg"
          }
        },
        "glitter-silver": {
          "id": "glitter-silver",
          "name": "Glitter Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115151\/glitter-silver.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115151\/glitter-silver-150x150.jpg"
          }
        },
        "glitter-rainbow-white": {
          "id": "glitter-rainbow-white",
          "name": "Glitter Rainbow White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115118\/glitter-rainbow-white.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09115118\/glitter-rainbow-white-150x150.jpg"
          }
        },
        "glitter-white-2": {
          "id": "glitter-white-2",
          "name": "Glitter White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09114949\/glitter-white.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/09114949\/glitter-white-150x150.jpg"
          }
        },
        "stripflock-light-pink": {
          "id": "stripflock-light-pink",
          "name": "StripFlock\u00ae Pro Light Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121943\/stripflock-light-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121943\/stripflock-light-pink-150x150.jpeg"
          }
        },
        "stripflock-fuchsia": {
          "id": "stripflock-fuchsia",
          "name": "StripFlock\u00ae Pro Fuchsia",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121939\/stripflock-fushia.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121939\/stripflock-fushia-150x150.jpeg"
          }
        },
        "stripflock-pro-purple": {
          "id": "stripflock-pro-purple",
          "name": "StripFlock\u00ae Pro Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121948\/stripflock-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121948\/stripflock-purple-150x150.jpeg"
          }
        },
        "stripflock-navy-blue": {
          "id": "stripflock-navy-blue",
          "name": "StripFlock\u00ae Pro Navy Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121944\/stripflock-navy-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121944\/stripflock-navy-blue-150x150.jpeg"
          }
        },
        "stripflock-royal-blue": {
          "id": "stripflock-royal-blue",
          "name": "StripFlock\u00ae Pro Royal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121950\/stripflock-royal-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121950\/stripflock-royal-blue-150x150.jpeg"
          }
        },
        "stripflock-turquoise": {
          "id": "stripflock-turquoise",
          "name": "StripFlock\u00ae Pro Turquoise",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121951\/stripflock-turquoise.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121951\/stripflock-turquoise-150x150.jpeg"
          }
        },
        "stripflock-pale-blue": {
          "id": "stripflock-pale-blue",
          "name": "StripFlock\u00ae Pro Pale Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121947\/stripflock-pale-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121947\/stripflock-pale-blue-150x150.jpeg"
          }
        },
        "stripflock-green": {
          "id": "stripflock-green",
          "name": "StripFlock\u00ae Pro Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121941\/stripflock-green.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121941\/stripflock-green-150x150.jpeg"
          }
        },
        "stripflock-lemon": {
          "id": "stripflock-lemon",
          "name": "StripFlock\u00ae Pro Lemon",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121942\/stripflock-lemon.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121942\/stripflock-lemon-150x150.jpeg"
          }
        },
        "stripflock-yellow": {
          "id": "stripflock-yellow",
          "name": "StripFlock\u00ae Pro Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121953\/stripflock-yellow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121953\/stripflock-yellow-150x150.jpeg"
          }
        },
        "stripflock-orange": {
          "id": "stripflock-orange",
          "name": "StripFlock\u00ae Pro Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121946\/stripflock-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121946\/stripflock-orange-150x150.jpeg"
          }
        },
        "stripflock-bright-red": {
          "id": "stripflock-bright-red",
          "name": "StripFlock\u00ae Pro Bright Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121935\/stripflock-bright-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121935\/stripflock-bright-red-150x150.jpeg"
          }
        },
        "stripflock-red": {
          "id": "stripflock-red",
          "name": "StripFlock\u00ae Pro Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121949\/stripflock-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121949\/stripflock-red-150x150.jpeg"
          }
        },
        "stripflock-burgundy": {
          "id": "stripflock-burgundy",
          "name": "StripFlock\u00ae Pro Burgundy",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121938\/stripflock-burgundy.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121938\/stripflock-burgundy-150x150.jpeg"
          }
        },
        "stripflock-brown": {
          "id": "stripflock-brown",
          "name": "StripFlock\u00ae Pro Brown",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121937\/stripflock-brown.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121937\/stripflock-brown-150x150.jpeg"
          }
        },
        "stripflock-black": {
          "id": "stripflock-black",
          "name": "StripFlock\u00ae Pro Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121934\/stripflock-black.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121934\/stripflock-black-150x150.jpg"
          }
        },
        "stripflock-anthracite": {
          "id": "stripflock-anthracite",
          "name": "StripFlock\u00ae Pro Anthracite",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121932\/stripflock-anthracite.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121932\/stripflock-anthracite-150x150.jpeg"
          }
        },
        "stripflock-gray": {
          "id": "stripflock-gray",
          "name": "StripFlock\u00ae Pro Gray",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121940\/stripflock-gray.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121940\/stripflock-gray-150x150.jpeg"
          }
        },
        "stripflock-white": {
          "id": "stripflock-white",
          "name": "StripFlock\u00ae Pro White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121952\/stripflock-white.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121952\/stripflock-white-150x150.jpeg"
          }
        },
        "twinkle-rainbow": {
          "id": "twinkle-rainbow",
          "name": "Twinkle\u2122 Rainbow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120452\/twinkle-rainbow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120452\/twinkle-rainbow-150x150.jpeg"
          }
        },
        "twinkle-fuchsia": {
          "id": "twinkle-fuchsia",
          "name": "Twinkle\u2122 Fuchsia",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120449\/twinkle-fushia.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120449\/twinkle-fushia-150x150.jpeg"
          }
        },
        "twinkle-purple": {
          "id": "twinkle-purple",
          "name": "Twinkle\u2122 Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120454\/twinkle-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120454\/twinkle-purple-150x150.jpeg"
          }
        },
        "twinkle-navy-blue": {
          "id": "twinkle-navy-blue",
          "name": "Twinkle\u2122 Navy Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120452\/twinkle-navy-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120452\/twinkle-navy-blue-150x150.jpeg"
          }
        },
        "twinkle-royal-blue": {
          "id": "twinkle-royal-blue",
          "name": "Twinkle\u2122 Royal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120455\/twinkle-royal-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120455\/twinkle-royal-blue-150x150.jpeg"
          }
        },
        "twinkle-aqua": {
          "id": "twinkle-aqua",
          "name": "Twinkle\u2122 Aqua",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120447\/twinkle-aqua.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120447\/twinkle-aqua-150x150.jpeg"
          }
        },
        "twinkle-green": {
          "id": "twinkle-green",
          "name": "Twinkle\u2122 Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120451\/twinkle-green.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120451\/twinkle-green-150x150.jpeg"
          }
        },
        "twinkle-gold": {
          "id": "twinkle-gold",
          "name": "Twinkle\u2122 Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120450\/twinkle-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120450\/twinkle-gold-150x150.jpeg"
          }
        },
        "twinkle-orange": {
          "id": "twinkle-orange",
          "name": "Twinkle\u2122 Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120453\/twinkle-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120453\/twinkle-orange-150x150.jpeg"
          }
        },
        "twinkle-red": {
          "id": "twinkle-red",
          "name": "Twinkle\u2122 Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120455\/twinkle-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120455\/twinkle-red-150x150.jpeg"
          }
        },
        "twinkle-silver-2": {
          "id": "twinkle-silver-2",
          "name": "Twinkle\u2122 Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120456\/twinkle-silver.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120456\/twinkle-silver-150x150.jpeg"
          }
        },
        "holo-rainbow-pearl": {
          "id": "holo-rainbow-pearl",
          "name": "Holographic Rainbow Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111442\/holo-rainbow-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111442\/holo-rainbow-pearl-150x150.jpeg"
          }
        },
        "holo-moonlit-pearl": {
          "id": "holo-moonlit-pearl",
          "name": "Holographic Moonlight Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111437\/holo-moonlit-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111437\/holo-moonlit-pearl-150x150.jpeg"
          }
        },
        "holo-rainforest-pearl": {
          "id": "holo-rainforest-pearl",
          "name": "Holographic Rainforest Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainforest-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainforest-pearl-150x150.jpeg"
          }
        },
        "holo-tropical-pearl": {
          "id": "holo-tropical-pearl",
          "name": "Holographic Tropical Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111448\/holo-tropical-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111448\/holo-tropical-pearl-150x150.jpeg"
          }
        },
        "holo-firelit-pearl": {
          "id": "holo-firelit-pearl",
          "name": "Holographic Firelit Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111432\/holo-firelit-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111432\/holo-firelit-pearl-150x150.jpeg"
          }
        },
        "holo-mystic-pearl": {
          "id": "holo-mystic-pearl",
          "name": "Holographic Mystic Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111438\/holo-mystic-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111438\/holo-mystic-pearl-150x150.jpeg"
          }
        },
        "holo-rainbow": {
          "id": "holo-rainbow",
          "name": "Holographic Rainbow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainbow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainbow-150x150.jpeg"
          }
        },
        "holo-gold-crystal": {
          "id": "holo-gold-crystal",
          "name": "Holographic Gold Crystal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111434\/holo-gold-crystal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111434\/holo-gold-crystal-150x150.jpeg"
          }
        },
        "holo-crystal": {
          "id": "holo-crystal",
          "name": "Holographic Crystal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111431\/holo-crystal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111431\/holo-crystal-150x150.jpeg"
          }
        },
        "holo-blush": {
          "id": "holo-blush",
          "name": "Holographic Blush",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111429\/holo-blush.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111429\/holo-blush-150x150.jpeg"
          }
        },
        "holo-light-pink": {
          "id": "holo-light-pink",
          "name": "Holographic Light Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111436\/holo-light-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111436\/holo-light-pink-150x150.jpeg"
          }
        },
        "holo-fuchsia": {
          "id": "holo-fuchsia",
          "name": "Holographic Fuchsia",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111433\/holo-fuchsia.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111433\/holo-fuchsia-150x150.jpeg"
          }
        },
        "holo-violet": {
          "id": "holo-violet",
          "name": "Holographic Violet",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111449\/holo-violet.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111449\/holo-violet-150x150.jpeg"
          }
        },
        "holo-purple": {
          "id": "holo-purple",
          "name": "Holographic Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111441\/holo-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111441\/holo-purple-150x150.jpeg"
          }
        },
        "holo-navy-blue": {
          "id": "holo-navy-blue",
          "name": "Holographic Navy Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111439\/holo-navy-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111439\/holo-navy-blue-150x150.jpeg"
          }
        },
        "holo-royal-blue": {
          "id": "holo-royal-blue",
          "name": "Holographic Royal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111445\/holo-royal-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111445\/holo-royal-blue-150x150.jpeg"
          }
        },
        "holo-aqua": {
          "id": "holo-aqua",
          "name": "Holographic Aqua",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111427\/holo-aqua.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111427\/holo-aqua-150x150.jpeg"
          }
        },
        "holo-sky": {
          "id": "holo-sky",
          "name": "Holographic Sky",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111447\/holo-sky.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111447\/holo-sky-150x150.jpeg"
          }
        },
        "holo-green": {
          "id": "holo-green",
          "name": "Holographic Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111436\/holo-green.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111436\/holo-green-150x150.jpeg"
          }
        },
        "holo-gold": {
          "id": "holo-gold",
          "name": "Holographic Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111435\/holo-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111435\/holo-gold-150x150.jpeg"
          }
        },
        "holo-orange": {
          "id": "holo-orange",
          "name": "Holographic Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111440\/holo-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111440\/holo-orange-150x150.jpeg"
          }
        },
        "holo-red": {
          "id": "holo-red",
          "name": "Holographic Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111444\/holo-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111444\/holo-red-150x150.jpeg"
          }
        },
        "holo-brown": {
          "id": "holo-brown",
          "name": "Holographic Brown",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111430\/holo-brown.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111430\/holo-brown-150x150.jpeg"
          }
        },
        "holo-black": {
          "id": "holo-black",
          "name": "Holographic Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111428\/holo-black.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111428\/holo-black-150x150.jpeg"
          }
        },
        "holo-silver": {
          "id": "holo-silver",
          "name": "Holographic Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111446\/holo-silver.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111446\/holo-silver-150x150.jpeg"
          }
        },
        "sparkle-clear": {
          "id": "sparkle-clear",
          "name": "Sparkle\u2122 Clear",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113314\/sparkle-clear-sparkle.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113314\/sparkle-clear-sparkle-150x150.jpeg"
          }
        },
        "sparkle-pink-lemonade": {
          "id": "sparkle-pink-lemonade",
          "name": "Sparkle\u2122 Pink Lemonade",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113320\/sparkle-pink-lemonade.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113320\/sparkle-pink-lemonade-150x150.jpeg"
          }
        },
        "sparkle-perfect-pink": {
          "id": "sparkle-perfect-pink",
          "name": "Sparkle\u2122 Perfect Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113319\/sparkle-perfect-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113319\/sparkle-perfect-pink-150x150.jpeg"
          }
        },
        "sparkle-grapevine": {
          "id": "sparkle-grapevine",
          "name": "Sparkle\u2122 Grapevine",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113317\/sparkle-grapevine.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113317\/sparkle-grapevine-150x150.jpeg"
          }
        },
        "sparkle-blue-jeans": {
          "id": "sparkle-blue-jeans",
          "name": "Sparkle\u2122 Blue Jeans",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113313\/sparkle-blue-jeans.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113313\/sparkle-blue-jeans-150x150.jpeg"
          }
        },
        "sparkle-cornflower-blue": {
          "id": "sparkle-cornflower-blue",
          "name": "Sparkle\u2122 Cornflower Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113315\/sparkle-cornflower-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113315\/sparkle-cornflower-blue-150x150.jpeg"
          }
        },
        "sparkle-green-leaf": {
          "id": "sparkle-green-leaf",
          "name": "Sparkle\u2122 Green Leaf",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113318\/sparkle-green-leaf.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113318\/sparkle-green-leaf-150x150.jpeg"
          }
        },
        "sparkle-gold-star": {
          "id": "sparkle-gold-star",
          "name": "Sparkle\u2122 Gold Star",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113316\/sparkle-gold-star.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113316\/sparkle-gold-star-150x150.jpeg"
          }
        },
        "sparkle-buttercup-yellow": {
          "id": "sparkle-buttercup-yellow",
          "name": "Sparkle\u2122 Buttercup Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113313\/sparkle-buttercup-yellow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113313\/sparkle-buttercup-yellow-150x150.jpeg"
          }
        },
        "sparkle-sunset-orange": {
          "id": "sparkle-sunset-orange",
          "name": "Sparkle\u2122 Sunset Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113322\/sparkle-sunset-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113322\/sparkle-sunset-orange-150x150.jpeg"
          }
        },
        "sparkle-tomato-red": {
          "id": "sparkle-tomato-red",
          "name": "Sparkle\u2122 Tomato Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113323\/sparkle-tomato-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113323\/sparkle-tomato-red-150x150.jpeg"
          }
        },
        "sparkle-midnight-black": {
          "id": "sparkle-midnight-black",
          "name": "Sparkle\u2122 Midnight Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113318\/sparkle-midnight-black.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113318\/sparkle-midnight-black-150x150.jpeg"
          }
        },
        "sparkle-silver-sword": {
          "id": "sparkle-silver-sword",
          "name": "Sparkle\u2122 Silver Sword",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113321\/sparkle-silver-sword.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113321\/sparkle-silver-sword-150x150.jpeg"
          }
        },
        "sparkle-snowstorm-white-2": {
          "id": "sparkle-snowstorm-white-2",
          "name": "Sparkle\u2122 Snowstorm White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113424\/sparkle-snowstorm-white.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113424\/sparkle-snowstorm-white-150x150.jpeg"
          }
        },
        "metal-tiger-lily-pink": {
          "id": "metal-tiger-lily-pink",
          "name": "Metal Tiger Lily Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165229\/metal-tiger-lily-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165229\/metal-tiger-lily-pink-150x150.jpeg"
          }
        },
        "metal-purple": {
          "id": "metal-purple",
          "name": "Metal Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165227\/metal-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165227\/metal-purple-150x150.jpeg"
          }
        },
        "metal-blue": {
          "id": "metal-blue",
          "name": "Metal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165224\/metal-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165224\/metal-blue-150x150.jpeg"
          }
        },
        "metal-silver-blue": {
          "id": "metal-silver-blue",
          "name": "Metal Silver Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165228\/metal-silver-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165228\/metal-silver-blue-150x150.jpeg"
          }
        },
        "metal-gold": {
          "id": "metal-gold",
          "name": "Metal Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165226\/metal-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165226\/metal-gold-150x150.jpeg"
          }
        },
        "metal-bronze": {
          "id": "metal-bronze",
          "name": "Metal Bronze",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165225\/metal-bronze.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165225\/metal-bronze-150x150.jpeg"
          }
        },
        "metal-red": {
          "id": "metal-red",
          "name": "Metal Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165227\/metal-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165227\/metal-red-150x150.jpeg"
          }
        },
        "metal-silver-2": {
          "id": "metal-silver-2",
          "name": "Metal Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165210\/metal-silver.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165210\/metal-silver-150x150.jpeg"
          }
        },
        "metal-golden-rose": {
          "id": "metal-golden-rose",
          "name": "Metal Golden Rose",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04164251\/metal-golden-rose.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04164251\/metal-golden-rose-150x150.jpeg"
          }
        },
        "ew-flamingo": {
          "id": "ew-flamingo",
          "name": "EasyWeed\u00ae Flamingo",
          "solid_hex_color": "#f09daf",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "blackboard": {
          "id": "blackboard",
          "name": "Blackboard\u00ae",
          "solid_hex_color": "#232323",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "ew-adhesive": {
          "id": "ew-adhesive",
          "name": "EasyWeed\u00ae Adhesive",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/14084847\/ew-adhesive.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/14084847\/ew-adhesive-150x150.jpeg"
          }
        },
        "subblock-white": {
          "id": "subblock-white",
          "name": "EasyWeed\u00ae Sub Block White",
          "solid_hex_color": "#EFF0F1",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "stretch-white": {
          "id": "stretch-white",
          "name": "EasyWeed\u00ae Stretch White",
          "solid_hex_color": "#ffffff",
          "tile_image_urls": []
        },
        "ew-glow": {
          "id": "ew-glow",
          "name": "EasyWeed\u00ae Glow in the Dark",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/12100637\/Glow-In-the-Dark.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/12100637\/Glow-In-the-Dark-150x150.png"
          }
        },
        "extra-black": {
          "id": "extra-black",
          "name": "EasyWeed\u00ae Extra Black",
          "solid_hex_color": "#050505",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        },
        "extra-white": {
          "id": "extra-white",
          "name": "EasyWeed\u00ae Extra White",
          "solid_hex_color": "#ffffff",
          "tile_image_urls": []
        },
        "electric-pearl": {
          "id": "electric-pearl",
          "name": "EasyWeed\u00ae\u00a0Electric Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143636\/electric-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/09143636\/electric-pearl-150x150.jpeg"
          }
        },
        "ew-silver": {
          "id": "ew-silver",
          "name": "EasyWeed\u00ae Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/12100513\/ew-silver.png",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/07\/12100513\/ew-silver-150x150.png"
          }
        },
        "ew-white": {
          "id": "ew-white",
          "name": "EasyWeed\u00ae White",
          "solid_hex_color": "#ffffff",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "hi5-print-matte": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "hi5-print-matte",
        "materials": [],
        "name": "Hi-5 Print (Matte)",
        "hi-5-print-matte": {
          "id": "hi-5-print-matte",
          "name": "Hi-5 Print Matte",
          "solid_hex_color": "#efefef",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "holographic": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 15,
              "speed": 10
            }
          }
        },
        "id": "holographic",
        "materials": [],
        "name": "Holographic",
        "holo-rainbow-pearl": {
          "id": "holo-rainbow-pearl",
          "name": "Holographic Rainbow Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111442\/holo-rainbow-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111442\/holo-rainbow-pearl-150x150.jpeg"
          }
        },
        "holo-moonlit-pearl": {
          "id": "holo-moonlit-pearl",
          "name": "Holographic Moonlight Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111437\/holo-moonlit-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111437\/holo-moonlit-pearl-150x150.jpeg"
          }
        },
        "holo-rainforest-pearl": {
          "id": "holo-rainforest-pearl",
          "name": "Holographic Rainforest Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainforest-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainforest-pearl-150x150.jpeg"
          }
        },
        "holo-tropical-pearl": {
          "id": "holo-tropical-pearl",
          "name": "Holographic Tropical Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111448\/holo-tropical-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111448\/holo-tropical-pearl-150x150.jpeg"
          }
        },
        "holo-firelit-pearl": {
          "id": "holo-firelit-pearl",
          "name": "Holographic Firelit Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111432\/holo-firelit-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111432\/holo-firelit-pearl-150x150.jpeg"
          }
        },
        "holo-mystic-pearl": {
          "id": "holo-mystic-pearl",
          "name": "Holographic Mystic Pearl",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111438\/holo-mystic-pearl.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111438\/holo-mystic-pearl-150x150.jpeg"
          }
        },
        "holo-rainbow": {
          "id": "holo-rainbow",
          "name": "Holographic Rainbow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainbow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111443\/holo-rainbow-150x150.jpeg"
          }
        },
        "holo-gold-crystal": {
          "id": "holo-gold-crystal",
          "name": "Holographic Gold Crystal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111434\/holo-gold-crystal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111434\/holo-gold-crystal-150x150.jpeg"
          }
        },
        "holo-crystal": {
          "id": "holo-crystal",
          "name": "Holographic Crystal",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111431\/holo-crystal.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111431\/holo-crystal-150x150.jpeg"
          }
        },
        "holo-blush": {
          "id": "holo-blush",
          "name": "Holographic Blush",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111429\/holo-blush.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111429\/holo-blush-150x150.jpeg"
          }
        },
        "holo-light-pink": {
          "id": "holo-light-pink",
          "name": "Holographic Light Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111436\/holo-light-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111436\/holo-light-pink-150x150.jpeg"
          }
        },
        "holo-fuchsia": {
          "id": "holo-fuchsia",
          "name": "Holographic Fuchsia",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111433\/holo-fuchsia.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111433\/holo-fuchsia-150x150.jpeg"
          }
        },
        "holo-violet": {
          "id": "holo-violet",
          "name": "Holographic Violet",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111449\/holo-violet.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111449\/holo-violet-150x150.jpeg"
          }
        },
        "holo-purple": {
          "id": "holo-purple",
          "name": "Holographic Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111441\/holo-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111441\/holo-purple-150x150.jpeg"
          }
        },
        "holo-navy-blue": {
          "id": "holo-navy-blue",
          "name": "Holographic Navy Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111439\/holo-navy-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111439\/holo-navy-blue-150x150.jpeg"
          }
        },
        "holo-royal-blue": {
          "id": "holo-royal-blue",
          "name": "Holographic Royal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111445\/holo-royal-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111445\/holo-royal-blue-150x150.jpeg"
          }
        },
        "holo-aqua": {
          "id": "holo-aqua",
          "name": "Holographic Aqua",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111427\/holo-aqua.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111427\/holo-aqua-150x150.jpeg"
          }
        },
        "holo-sky": {
          "id": "holo-sky",
          "name": "Holographic Sky",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111447\/holo-sky.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111447\/holo-sky-150x150.jpeg"
          }
        },
        "holo-green": {
          "id": "holo-green",
          "name": "Holographic Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111436\/holo-green.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111436\/holo-green-150x150.jpeg"
          }
        },
        "holo-gold": {
          "id": "holo-gold",
          "name": "Holographic Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111435\/holo-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111435\/holo-gold-150x150.jpeg"
          }
        },
        "holo-orange": {
          "id": "holo-orange",
          "name": "Holographic Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111440\/holo-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111440\/holo-orange-150x150.jpeg"
          }
        },
        "holo-red": {
          "id": "holo-red",
          "name": "Holographic Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111444\/holo-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111444\/holo-red-150x150.jpeg"
          }
        },
        "holo-brown": {
          "id": "holo-brown",
          "name": "Holographic Brown",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111430\/holo-brown.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111430\/holo-brown-150x150.jpeg"
          }
        },
        "holo-black": {
          "id": "holo-black",
          "name": "Holographic Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111428\/holo-black.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111428\/holo-black-150x150.jpeg"
          }
        },
        "holo-silver": {
          "id": "holo-silver",
          "name": "Holographic Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111446\/holo-silver.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08111446\/holo-silver-150x150.jpeg"
          }
        }
      },
      "metal": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "metal",
        "materials": [],
        "name": "Metal",
        "metal-tiger-lily-pink": {
          "id": "metal-tiger-lily-pink",
          "name": "Metal Tiger Lily Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165229\/metal-tiger-lily-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165229\/metal-tiger-lily-pink-150x150.jpeg"
          }
        },
        "metal-purple": {
          "id": "metal-purple",
          "name": "Metal Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165227\/metal-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165227\/metal-purple-150x150.jpeg"
          }
        },
        "metal-blue": {
          "id": "metal-blue",
          "name": "Metal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165224\/metal-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165224\/metal-blue-150x150.jpeg"
          }
        },
        "metal-silver-blue": {
          "id": "metal-silver-blue",
          "name": "Metal Silver Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165228\/metal-silver-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165228\/metal-silver-blue-150x150.jpeg"
          }
        },
        "metal-gold": {
          "id": "metal-gold",
          "name": "Metal Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165226\/metal-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165226\/metal-gold-150x150.jpeg"
          }
        },
        "metal-bronze": {
          "id": "metal-bronze",
          "name": "Metal Bronze",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165225\/metal-bronze.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165225\/metal-bronze-150x150.jpeg"
          }
        },
        "metal-red": {
          "id": "metal-red",
          "name": "Metal Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165227\/metal-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165227\/metal-red-150x150.jpeg"
          }
        },
        "metal-silver-2": {
          "id": "metal-silver-2",
          "name": "Metal Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165210\/metal-silver.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04165210\/metal-silver-150x150.jpeg"
          }
        },
        "metal-golden-rose": {
          "id": "metal-golden-rose",
          "name": "Metal Golden Rose",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04164251\/metal-golden-rose.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/04164251\/metal-golden-rose-150x150.jpeg"
          }
        }
      },
      "s-print": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "s-print",
        "materials": [],
        "name": "S-Print\u2122",
        "s-print": {
          "id": "s-print",
          "name": "S-Print\u2122 (Matte)",
          "solid_hex_color": "#eaeaea",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "sparkleprint": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "sparkleprint",
        "materials": [],
        "name": "SparklePrint\u2122",
        "sparkleprint": {
          "id": "sparkleprint",
          "name": "SparklePrint\u2122 (Gloss)",
          "solid_hex_color": "#ededed",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "sparkle": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "sparkle",
        "materials": [],
        "name": "Sparkle\u2122",
        "sparkle-clear": {
          "id": "sparkle-clear",
          "name": "Sparkle\u2122 Clear",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113314\/sparkle-clear-sparkle.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113314\/sparkle-clear-sparkle-150x150.jpeg"
          }
        },
        "sparkle-pink-lemonade": {
          "id": "sparkle-pink-lemonade",
          "name": "Sparkle\u2122 Pink Lemonade",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113320\/sparkle-pink-lemonade.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113320\/sparkle-pink-lemonade-150x150.jpeg"
          }
        },
        "sparkle-perfect-pink": {
          "id": "sparkle-perfect-pink",
          "name": "Sparkle\u2122 Perfect Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113319\/sparkle-perfect-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113319\/sparkle-perfect-pink-150x150.jpeg"
          }
        },
        "sparkle-grapevine": {
          "id": "sparkle-grapevine",
          "name": "Sparkle\u2122 Grapevine",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113317\/sparkle-grapevine.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113317\/sparkle-grapevine-150x150.jpeg"
          }
        },
        "sparkle-blue-jeans": {
          "id": "sparkle-blue-jeans",
          "name": "Sparkle\u2122 Blue Jeans",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113313\/sparkle-blue-jeans.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113313\/sparkle-blue-jeans-150x150.jpeg"
          }
        },
        "sparkle-cornflower-blue": {
          "id": "sparkle-cornflower-blue",
          "name": "Sparkle\u2122 Cornflower Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113315\/sparkle-cornflower-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113315\/sparkle-cornflower-blue-150x150.jpeg"
          }
        },
        "sparkle-green-leaf": {
          "id": "sparkle-green-leaf",
          "name": "Sparkle\u2122 Green Leaf",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113318\/sparkle-green-leaf.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113318\/sparkle-green-leaf-150x150.jpeg"
          }
        },
        "sparkle-gold-star": {
          "id": "sparkle-gold-star",
          "name": "Sparkle\u2122 Gold Star",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113316\/sparkle-gold-star.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113316\/sparkle-gold-star-150x150.jpeg"
          }
        },
        "sparkle-buttercup-yellow": {
          "id": "sparkle-buttercup-yellow",
          "name": "Sparkle\u2122 Buttercup Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113313\/sparkle-buttercup-yellow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113313\/sparkle-buttercup-yellow-150x150.jpeg"
          }
        },
        "sparkle-sunset-orange": {
          "id": "sparkle-sunset-orange",
          "name": "Sparkle\u2122 Sunset Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113322\/sparkle-sunset-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113322\/sparkle-sunset-orange-150x150.jpeg"
          }
        },
        "sparkle-tomato-red": {
          "id": "sparkle-tomato-red",
          "name": "Sparkle\u2122 Tomato Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113323\/sparkle-tomato-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113323\/sparkle-tomato-red-150x150.jpeg"
          }
        },
        "sparkle-midnight-black": {
          "id": "sparkle-midnight-black",
          "name": "Sparkle\u2122 Midnight Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113318\/sparkle-midnight-black.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113318\/sparkle-midnight-black-150x150.jpeg"
          }
        },
        "sparkle-silver-sword": {
          "id": "sparkle-silver-sword",
          "name": "Sparkle\u2122 Silver Sword",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113321\/sparkle-silver-sword.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113321\/sparkle-silver-sword-150x150.jpeg"
          }
        },
        "sparkle-snowstorm-white-2": {
          "id": "sparkle-snowstorm-white-2",
          "name": "Sparkle\u2122 Snowstorm White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113424\/sparkle-snowstorm-white.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/05113424\/sparkle-snowstorm-white-150x150.jpeg"
          }
        }
      },
      "stripflock-pro": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 60,
              "force": 15,
              "speed": 10
            }
          }
        },
        "id": "stripflock-pro",
        "materials": [],
        "name": "StripFlock\u00ae Pro",
        "stripflock-light-pink": {
          "id": "stripflock-light-pink",
          "name": "StripFlock\u00ae Pro Light Pink",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121943\/stripflock-light-pink.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121943\/stripflock-light-pink-150x150.jpeg"
          }
        },
        "stripflock-fuchsia": {
          "id": "stripflock-fuchsia",
          "name": "StripFlock\u00ae Pro Fuchsia",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121939\/stripflock-fushia.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121939\/stripflock-fushia-150x150.jpeg"
          }
        },
        "stripflock-pro-purple": {
          "id": "stripflock-pro-purple",
          "name": "StripFlock\u00ae Pro Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121948\/stripflock-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121948\/stripflock-purple-150x150.jpeg"
          }
        },
        "stripflock-navy-blue": {
          "id": "stripflock-navy-blue",
          "name": "StripFlock\u00ae Pro Navy Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121944\/stripflock-navy-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121944\/stripflock-navy-blue-150x150.jpeg"
          }
        },
        "stripflock-royal-blue": {
          "id": "stripflock-royal-blue",
          "name": "StripFlock\u00ae Pro Royal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121950\/stripflock-royal-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121950\/stripflock-royal-blue-150x150.jpeg"
          }
        },
        "stripflock-turquoise": {
          "id": "stripflock-turquoise",
          "name": "StripFlock\u00ae Pro Turquoise",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121951\/stripflock-turquoise.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121951\/stripflock-turquoise-150x150.jpeg"
          }
        },
        "stripflock-pale-blue": {
          "id": "stripflock-pale-blue",
          "name": "StripFlock\u00ae Pro Pale Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121947\/stripflock-pale-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121947\/stripflock-pale-blue-150x150.jpeg"
          }
        },
        "stripflock-green": {
          "id": "stripflock-green",
          "name": "StripFlock\u00ae Pro Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121941\/stripflock-green.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121941\/stripflock-green-150x150.jpeg"
          }
        },
        "stripflock-lemon": {
          "id": "stripflock-lemon",
          "name": "StripFlock\u00ae Pro Lemon",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121942\/stripflock-lemon.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121942\/stripflock-lemon-150x150.jpeg"
          }
        },
        "stripflock-yellow": {
          "id": "stripflock-yellow",
          "name": "StripFlock\u00ae Pro Yellow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121953\/stripflock-yellow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121953\/stripflock-yellow-150x150.jpeg"
          }
        },
        "stripflock-orange": {
          "id": "stripflock-orange",
          "name": "StripFlock\u00ae Pro Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121946\/stripflock-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121946\/stripflock-orange-150x150.jpeg"
          }
        },
        "stripflock-bright-red": {
          "id": "stripflock-bright-red",
          "name": "StripFlock\u00ae Pro Bright Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121935\/stripflock-bright-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121935\/stripflock-bright-red-150x150.jpeg"
          }
        },
        "stripflock-red": {
          "id": "stripflock-red",
          "name": "StripFlock\u00ae Pro Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121949\/stripflock-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121949\/stripflock-red-150x150.jpeg"
          }
        },
        "stripflock-burgundy": {
          "id": "stripflock-burgundy",
          "name": "StripFlock\u00ae Pro Burgundy",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121938\/stripflock-burgundy.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121938\/stripflock-burgundy-150x150.jpeg"
          }
        },
        "stripflock-brown": {
          "id": "stripflock-brown",
          "name": "StripFlock\u00ae Pro Brown",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121937\/stripflock-brown.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121937\/stripflock-brown-150x150.jpeg"
          }
        },
        "stripflock-black": {
          "id": "stripflock-black",
          "name": "StripFlock\u00ae Pro Black",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121934\/stripflock-black.jpg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121934\/stripflock-black-150x150.jpg"
          }
        },
        "stripflock-anthracite": {
          "id": "stripflock-anthracite",
          "name": "StripFlock\u00ae Pro Anthracite",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121932\/stripflock-anthracite.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121932\/stripflock-anthracite-150x150.jpeg"
          }
        },
        "stripflock-gray": {
          "id": "stripflock-gray",
          "name": "StripFlock\u00ae Pro Gray",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121940\/stripflock-gray.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121940\/stripflock-gray-150x150.jpeg"
          }
        },
        "stripflock-white": {
          "id": "stripflock-white",
          "name": "StripFlock\u00ae Pro White",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121952\/stripflock-white.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08121952\/stripflock-white-150x150.jpeg"
          }
        }
      },
      "sublimation-markers": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "sublimation-markers",
        "materials": [],
        "name": "Sublimation Markers",
        "siser-sublimation-markers": {
          "id": "siser-sublimation-markers",
          "name": "Siser\u00ae Sublimation Markers",
          "solid_hex_color": "",
          "tile_image_urls": []
        }
      },
      "sublithin-soft-digital-media": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "sublithin-soft-digital-media",
        "materials": [],
        "name": "Sublithin\u00ae Soft",
        "sublithin-soft": {
          "id": "sublithin-soft",
          "name": "Sublithin\u00ae Soft (Matte)",
          "solid_hex_color": "#e8e8e8",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "ttd-masks": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 5,
              "speed": 10
            }
          }
        },
        "id": "ttd-masks",
        "materials": [],
        "name": "TTD Masks",
        "ttd-easy-mask": {
          "id": "ttd-easy-mask",
          "name": "TTD Easy Mask",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": false,
            "thumbnail": false
          }
        }
      },
      "twinkle": {
        "machine_settings": {
          "siser-skycut": {
            "cut": {
              "blade_angle": 45,
              "force": 20,
              "speed": 10
            }
          }
        },
        "id": "twinkle",
        "materials": [],
        "name": "Twinkle\u2122",
        "twinkle-rainbow": {
          "id": "twinkle-rainbow",
          "name": "Twinkle\u2122 Rainbow",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120452\/twinkle-rainbow.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120452\/twinkle-rainbow-150x150.jpeg"
          }
        },
        "twinkle-fuchsia": {
          "id": "twinkle-fuchsia",
          "name": "Twinkle\u2122 Fuchsia",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120449\/twinkle-fushia.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120449\/twinkle-fushia-150x150.jpeg"
          }
        },
        "twinkle-purple": {
          "id": "twinkle-purple",
          "name": "Twinkle\u2122 Purple",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120454\/twinkle-purple.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120454\/twinkle-purple-150x150.jpeg"
          }
        },
        "twinkle-navy-blue": {
          "id": "twinkle-navy-blue",
          "name": "Twinkle\u2122 Navy Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120452\/twinkle-navy-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120452\/twinkle-navy-blue-150x150.jpeg"
          }
        },
        "twinkle-royal-blue": {
          "id": "twinkle-royal-blue",
          "name": "Twinkle\u2122 Royal Blue",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120455\/twinkle-royal-blue.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120455\/twinkle-royal-blue-150x150.jpeg"
          }
        },
        "twinkle-aqua": {
          "id": "twinkle-aqua",
          "name": "Twinkle\u2122 Aqua",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120447\/twinkle-aqua.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120447\/twinkle-aqua-150x150.jpeg"
          }
        },
        "twinkle-green": {
          "id": "twinkle-green",
          "name": "Twinkle\u2122 Green",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120451\/twinkle-green.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120451\/twinkle-green-150x150.jpeg"
          }
        },
        "twinkle-gold": {
          "id": "twinkle-gold",
          "name": "Twinkle\u2122 Gold",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120450\/twinkle-gold.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120450\/twinkle-gold-150x150.jpeg"
          }
        },
        "twinkle-orange": {
          "id": "twinkle-orange",
          "name": "Twinkle\u2122 Orange",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120453\/twinkle-orange.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120453\/twinkle-orange-150x150.jpeg"
          }
        },
        "twinkle-red": {
          "id": "twinkle-red",
          "name": "Twinkle\u2122 Red",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120455\/twinkle-red.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120455\/twinkle-red-150x150.jpeg"
          }
        },
        "twinkle-silver-2": {
          "id": "twinkle-silver-2",
          "name": "Twinkle\u2122 Silver",
          "solid_hex_color": "",
          "tile_image_urls": {
            "full": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120456\/twinkle-silver.jpeg",
            "thumbnail": "https:\/\/cdn.leonardodesignstudio.com\/wp-content\/uploads\/2022\/08\/08120456\/twinkle-silver-150x150.jpeg"
          }
        }
      }
    }
  };
}